<template>
        <defaultSec :returnState="true">
            <template #title>
                <div class="default-header work-order-page-header">
                    <h3 v-if="editAble" class="work-order-page-title work-order-page-title--clickable" @click="returnPage">&lt; 工单详情</h3>
                    <h3 v-else class="work-order-page-title">工单详情</h3>
                    <div v-if="String(workOrderNo) !== '0'" class="work-order-header-meta">
                        <div class="work-order-header-meta-item">
                            <span class="work-order-header-meta-label">工单编号</span>
                            <span class="work-order-header-meta-value">{{workOrderInfo.workOrderNo || '-'}}</span>
                        </div>
                        <div class="work-order-header-meta-item">
                            <span class="work-order-header-meta-label">创建时间</span>
                            <span class="work-order-header-meta-value">{{workOrderInfo.createTime || '-'}}</span>
                        </div>
                        <div class="work-order-header-meta-item">
                            <span class="work-order-header-meta-label">创建人</span>
                            <span class="work-order-header-meta-value">{{workOrderInfo.createUserName || userNameById(workOrderInfo.createUserId) || '-'}}</span>
                        </div>
                    </div>
                    <div v-if="(editAble && !canFullEdit) || canPhysicalDelete" class="work-order-header-actions">
                        <el-button
                            v-if="canPhysicalDelete"
                            class="work-order-header-action work-order-header-action--delete"
                            size="small"
                            type="danger"
                            plain
                            icon="el-icon-delete"
                            :loading="physicalDeleting"
                            @click="physicalDeleteWorkOrder">
                            物理删除工单
                        </el-button>
                        <el-button
                            v-if="editAble && !canFullEdit"
                            class="work-order-header-action"
                            size="small"
                            type="danger"
                            :loading="saving"
                            :disabled="uploadingCount > 0"
                            @click="submitWorkOrder">
                            {{uploadingCount > 0 ? '图片上传中' : '保存工单'}}
                        </el-button>
                    </div>

                </div>

            </template>
            <div class="work-order-detail-info" v-loading="loading">
                <el-tabs v-model="detailActiveTab" type="border-card" @tab-click="handleDetailTabClick">
                    <el-tab-pane label="工单信息" name="BASIC_INFO">
                        <el-card
                            v-if="editAble && String(workOrderNo) === '0'"
                            class="ai-draft-card"
                            shadow="never">
                            <div slot="header" class="ai-draft-header">
                                <div>
                                    <span class="ai-draft-title"><i class="el-icon-magic-stick"></i> AI 识别工单</span>
                                    <span class="ai-draft-subtitle">粘贴聊天记录、订单信息和图片，识别后仅回填下方草稿</span>
                                </div>
                                <div class="ai-draft-header-actions">
                                    <el-tag size="mini" type="warning">AI仅辅助回填，请核对后手动提交</el-tag>
                                    <el-button type="text" size="small" @click="aiDraftExpanded = !aiDraftExpanded">
                                        {{aiDraftExpanded ? '收起' : '展开'}}
                                        <i :class="aiDraftExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                                    </el-button>
                                </div>
                            </div>
                            <div v-show="aiDraftExpanded">
                            <el-input
                                v-model="aiInputText"
                                type="textarea"
                                :rows="5"
                                maxlength="8000"
                                show-word-limit
                                placeholder="可直接粘贴混合信息，例如：订单号、客户反馈、批次、希望生产确认的问题、已有沟通结果……"
                                @paste.native="handleAiPaste">
                            </el-input>
                            <div class="ai-draft-actions">
                                <div tabindex="0" class="ai-paste-zone" @paste="handleAiPaste">
                                    <i class="el-icon-document-copy"></i> 点击后粘贴图片
                                </div>
                                <el-upload
                                    :show-file-list="false"
                                    multiple
                                    accept="image/*"
                                    :action="''"
                                    :httpRequest="uploadAiImage">
                                    <el-button size="small" plain type="primary" :loading="aiUploadingCount > 0">
                                        上传图片（最多10张）
                                    </el-button>
                                </el-upload>
                                <el-button
                                    size="small"
                                    type="primary"
                                    icon="el-icon-magic-stick"
                                    :loading="aiRecognizing"
                                    :disabled="aiUploadingCount > 0"
                                    @click="recognizeAiDraft">
                                    {{aiUploadingCount > 0 ? '图片上传中' : '开始识别并回填'}}
                                </el-button>
                                <span class="ai-draft-tip">可只填文字或只传图片；识别过程不会创建、保存或提交工单。</span>
                            </div>
                            <div v-if="aiImages.length" class="ai-image-list">
                                <div v-for="(item,index) in aiImages" :key="item.url" class="ai-image-item">
                                    <el-image
                                        :src="item.url"
                                        class="ai-image"
                                        :preview-src-list="aiImageUrls">
                                    </el-image>
                                    <el-button
                                        class="ai-image-delete"
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        size="mini"
                                        title="删除图片"
                                        @click="removeAiImage(index)">
                                    </el-button>
                                </div>
                            </div>
                            <el-alert
                                v-if="aiResultVisible"
                                class="ai-result-alert"
                                title="AI 识别结果已回填到下方，请逐项核对后再保存工单"
                                type="success"
                                :closable="false"
                                show-icon>
                            </el-alert>
                            <div v-if="aiWarnings.length" class="ai-feedback-list">
                                <div class="ai-feedback-title">需要注意</div>
                                <div v-for="(item,index) in aiWarnings" :key="'warning-' + index" class="ai-warning-item">
                                    <i class="el-icon-warning-outline"></i> {{item}}
                                </div>
                            </div>
                            <div v-if="aiUnresolvedFields.length" class="ai-unresolved-fields">
                                <span>仍需人工补充：</span>
                                <el-tag
                                    v-for="item in aiUnresolvedFields"
                                    :key="item"
                                    size="mini"
                                    type="warning">
                                    {{aiFieldLabel(item)}}
                                </el-tag>
                            </div>
                            </div>
                        </el-card>
                        <div class="form-section-heading">
                            <span class="form-section-index">1</span>
                            <div>
                                <div class="form-section-title">关联对象</div>
                                <div class="form-section-description">先确认购买渠道和关联订单；线下订单只展示需要人工补录的商品字段。</div>
                            </div>
                        </div>
                        <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>

                            <el-descriptions-item label="购买渠道">
                                <template slot="label">
                                    <span style="color: #e50011">*</span> 购买渠道
                                </template>
                                <el-radio-group :disabled="!editAble||!canFullEdit" size="mini" v-model="workOrderInfo.orderOnline">
                                    <el-radio :label="1">线上</el-radio>
                                    <el-radio :label="2">线下</el-radio>
                                </el-radio-group>
                            </el-descriptions-item>
                            <template v-if="workOrderInfo.orderOnline==2">
                                <el-descriptions-item label="线下门店">
                                    <el-input :disabled="!editAble||!canFullEdit" size="small" v-model="workOrderInfo.offlineShopName" placeholder="请输入线下门店信息" ></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item label="线下单号">
                                    <el-input :disabled="!editAble||!canFullEdit" size="small" v-model="workOrderInfo.offlineOrderNo" placeholder="请输入线下订单号" ></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item label="商品名称">
                                    <template slot="label"><span style="color: #e50011">*</span> 商品名称</template>
                                    <template v-if="canFullEdit">
                                        <el-select
                                            v-model="offlineProduct.barCode"
                                            :disabled="!editAble"
                                            :loading="offlineProductLoading"
                                            filterable
                                            clearable
                                            size="small"
                                            style="width: 100%"
                                            placeholder="请选择系统商品"
                                            @visible-change="handleOfflineProductDropdownVisible"
                                            @change="handleOfflineProductChange">
                                            <el-option
                                                v-for="item in offlineProductOptions"
                                                :key="item.cguid || item.cbarcode"
                                                :label="offlineProductOptionLabel(item)"
                                                :value="item.cbarcode">
                                            </el-option>
                                        </el-select>
                                        <div class="field-tip">从系统商品中选择，选中后自动带出 69 码和物品编码。</div>
                                    </template>
                                    <span v-else>{{ offlineProduct.productName || '-' }}</span>
                                </el-descriptions-item>
                                <el-descriptions-item label="69码">
                                    <template slot="label"><span style="color: #e50011">*</span> 69码</template>
                                    <el-input v-if="canFullEdit" :value="offlineProduct.barCode" readonly size="small" placeholder="选择商品后自动填写"></el-input>
                                    <span v-else>{{ offlineProduct.barCode || '-' }}</span>
                                </el-descriptions-item>
                                <el-descriptions-item label="物品编码">
                                    <template slot="label"><span style="color: #e50011">*</span> 物品编码</template>
                                    <el-input v-if="canFullEdit" :value="offlineProduct.productCode" readonly size="small" placeholder="选择商品后自动填写"></el-input>
                                    <span v-else>{{ offlineProduct.productCode || '-' }}</span>
                                </el-descriptions-item>
                                <el-descriptions-item label="批次">
                                    <template slot="label"><span style="color: #e50011">*</span> 批次</template>
                                    <el-input v-if="canFullEdit" :disabled="!editAble" size="small" v-model="offlineProduct.pici" placeholder="线下工单必填"></el-input>
                                    <span v-else>{{ offlineProduct.pici || '-' }}</span>
                                </el-descriptions-item>
                            </template>
                            <template v-else-if="workOrderInfo.orderOnline==1">
                                <el-descriptions-item label="工单来源">
                                    <el-select :disabled="!editAble||!canFullEdit" size="small" style="width: 100%" v-model="workOrderInfo.orderSource" placeholder="请选择">
                                        <el-option
                                            v-for="item in orderSourceList"
                                            :key="item.key"
                                            :label="item.name"
                                            :value="item.key">
                                        </el-option>
                                    </el-select>
                                </el-descriptions-item>
                                <el-descriptions-item label="店铺">
                                    {{workOrderInfo.onlineShopName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="外部单号">
                                    <el-input :disabled="!editAble||!canFullEdit" size="small" v-model="workOrderInfo.someID" placeholder="请输入外部单号的 订单号/售后单号" >
                                        <el-button  v-if="editAble&&canFullEdit&&workOrderInfo.workOrderStatus!=10" size="small" slot="append" type="primary" :loading="loading" @click="getOrder">获取订单明细</el-button>
                                    </el-input>
                                </el-descriptions-item>
                                <el-descriptions-item label="外部单号类型">
                                <span style="color: #209e91">
                                    {{relateTypeText(workOrderInfo.relateType)}}
                                </span>
                                </el-descriptions-item>
                            </template>

                        </el-descriptions>
                        <div class="form-section-heading">
                            <span class="form-section-index">2</span>
                            <div>
                                <div class="form-section-title">客户与沟通信息</div>
                                <div class="form-section-description">选填；订单已带回时可直接核对和补充。</div>
                            </div>
                        </div>
                        <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>
                                <el-descriptions-item label="联系人">
                                    <el-input :disabled="!editAble" size="small" v-model="workOrderInfo.contactName" placeholder="请输入联系人"></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item label="联系电话">
                                    <el-input :disabled="!editAble" size="small" v-model="workOrderInfo.contactPhone" placeholder="请输入联系电话"></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item label="联系地址" :span="2">
                                    <el-input :disabled="!editAble" size="small" v-model="workOrderInfo.contactAddr" placeholder="请输入联系地址"></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item label="沟通状态">
                                    <el-select v-if="editAble" v-model="workOrderInfo.communicationStatus" size="small" style="width: 100%" placeholder="请选择沟通状态">
                                        <el-option v-for="item in communicationStatusOptions" :key="item.value" :label="item.label" :value="item.value" :disabled="item.value === 'REPLIED' && !workOrderInfo.productionReply"></el-option>
                                    </el-select>
                                    <el-tag v-else :type="communicationStatusTagType(workOrderInfo.communicationStatus)">{{communicationStatusText(workOrderInfo.communicationStatus)}}</el-tag>
                                </el-descriptions-item>
                                <el-descriptions-item label="沟通结果">
                                    <el-input v-if="editAble" v-model="workOrderInfo.communicationResult" type="textarea" :rows="3" placeholder="已有处理结论、退款/补发结果等，可直接填写在这里"></el-input>
                                    <span v-else class="pre-line-text">{{workOrderInfo.communicationResult || '-'}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item label="待生产回复问题" :span="2">
                                    <el-input v-if="editAble" v-model="workOrderInfo.productionQuestion" type="textarea" :rows="3" placeholder="需要生产同事判断或回复的问题；选择“待生产回复”时必填"></el-input>
                                    <span v-else class="pre-line-text">{{workOrderInfo.productionQuestion || '-'}}</span>
                                </el-descriptions-item>
                        </el-descriptions>
                        <div class="form-section-heading">
                            <span class="form-section-index">3</span>
                            <div>
                                <div class="form-section-title">问题信息</div>
                                <div class="form-section-description">先选择工单类型，再补充该类型需要的问题、路由和举证信息。</div>
                            </div>
                        </div>
                        <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>
                            <el-descriptions-item label="工单类型">
                                <template slot="label">
                                    <span style="color: #e50011">*</span> 工单类型
                                </template>
                                <el-cascader
                                    v-if="useStableClassification"
                                    size="small"
                                    :disabled="!editAble||!canFullEdit"
                                    v-model="workOrderInfo.issueCode"
                                    placeholder="请选择工单类型"
                                    style="width: 100%"
                                    filterable
                                    :options="stableTypeCascaderOptions"
                                    :props="{emitPath:false}"
                                    @change="handleStableTypeChange">
                                </el-cascader>
                                <el-cascader
                                    v-else
                                    size="small"
                                    :disabled="!editAble||!canFullEdit"
                                    v-model="workOrderInfo.workOrderTypeCode"
                                    placeholder="请选择历史售后类型"
                                    style="width: 100%"
                                    :options="legacyTypeOptions"
                                    :props="{emitPath:false}"
                                    @change="(val)=>handleWorkTypeChange(val,'workType')">
                                </el-cascader>
                                <div v-if="!useStableClassification" class="field-tip">
                                    该工单使用历史分类，保存时仍按原分类处理，不迁移历史数据。
                                </div>
                                <div v-if="useStableClassification && isOfflineRefundIssue" class="field-tip">
                                    线下打款没有二级问题，处理结果固定为赔付；赔付专员完成打款并上传凭证后直接关闭工单，无需责任划分。
                                </div>
                            </el-descriptions-item>
                            <template v-if="useStableClassification && isQualityIssue">
                                <el-descriptions-item label="商品温层">
                                    <template slot="label"><span style="color: #e50011">*</span> 商品温层</template>
                                    <el-radio-group
                                        v-if="editAble && canFullEdit"
                                        v-model="workOrderInfo.temperatureZone"
                                        size="mini"
                                        @change="handleTemperatureZoneChange">
                                        <el-radio-button label="COLD">低温</el-radio-button>
                                        <el-radio-button label="AMBIENT">常温</el-radio-button>
                                        <el-radio-button label="UNKNOWN">待确认</el-radio-button>
                                    </el-radio-group>
                                    <el-tag v-else :type="temperatureZoneTagType(workOrderInfo.temperatureZone)">
                                        {{temperatureZoneText(workOrderInfo.temperatureZone)}}
                                    </el-tag>
                                    <div class="field-tip">仅质量工单需要；订单可识别时自动判定，数据缺失或冲突时请人工确认。</div>
                                </el-descriptions-item>
                                <el-descriptions-item label="产品线">
                                    <template slot="label">
                                        <span style="color: #e50011">*</span> 产品线
                                    </template>
                                    <el-select
                                        v-if="editAble && canFullEdit"
                                        v-model="workOrderInfo.productLineCode"
                                        :disabled="!isSupportedTemperatureZone"
                                        filterable
                                        size="small"
                                        style="width: 100%"
                                        placeholder="请先确认温层"
                                        @change="handleProductLineChange">
                                        <el-option
                                            v-for="item in productLineOptions"
                                            :key="item.productLineCode"
                                            :label="item.productLineName"
                                            :value="item.productLineCode"
                                            :disabled="item.disabled">
                                        </el-option>
                                    </el-select>
                                    <span v-else>{{workOrderInfo.workOrderTypeMatClass || '-'}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item label="工厂">
                                    <template slot="label">
                                        <span style="color: #e50011">*</span> 工厂
                                    </template>
                                    <el-select
                                        v-if="editAble && canFullEdit"
                                        v-model="workOrderInfo.factoryCode"
                                        :disabled="false"
                                        size="small"
                                        style="width: 100%"
                                        placeholder="请选择"
                                        @change="handleFactoryChange">
                                        <el-option
                                            v-for="item in factorySelectOptions"
                                            :key="item.factoryCode"
                                            :label="item.factoryName"
                                            :value="item.factoryCode"
                                            :disabled="item.disabled">
                                        </el-option>
                                    </el-select>
                                    <span v-else>{{workOrderInfo.workOrderTypeFactory || '-'}}</span>
                                    <div class="field-tip">工厂与产品线独立；工厂必选。</div>
                                </el-descriptions-item>
                            </template>
                            <el-descriptions-item v-if="isQualityIssue" label="寄回单号">
                                <el-input
                                    v-if="editAble"
                                    v-model.trim="workOrderInfo.qualityReturnTrackingNo"
                                    maxlength="100"
                                    show-word-limit
                                    clearable
                                    size="small"
                                    placeholder="请输入客户寄回物流单号">
                                </el-input>
                                <span v-else>{{workOrderInfo.qualityReturnTrackingNo || '-'}}</span>
                                <div class="field-tip">仅质量问题使用，可在工单提交后补录。</div>
                            </el-descriptions-item>
                            <el-descriptions-item v-if="useStableClassification && isOperationIssue && !isOfflineRefundIssue" label="关联店铺">
                                <span>{{workOrderInfo.onlineShopName || '-'}}</span>
                                <el-tag v-if="workOrderInfo.shopCode" size="mini" type="info">{{workOrderInfo.shopCode}}</el-tag>
                                <div class="field-tip">店铺以订单数据为准，并自动匹配运营通知处理人。</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="通知处理人">
                                <template slot="label"><span v-if="!isOfflineRefundIssue" style="color: #e50011">*</span> 通知处理人</template>
                                <el-select v-if="!useStableClassification" filterable :disabled="!editAble||!canFullEdit" size="small" @change="(val)=>handleWorkTypeChange(val,'handleUserId')" style="width: 100%" v-model="workOrderInfo.handleUserId" placeholder="请选择通知处理人">
                                    <el-option v-for="item in userList" :key="item.USER_ID" :label="userDisplayName(item)" :value="item.USER_ID"></el-option>
                                </el-select>
                                <template v-else-if="isQualityIssue && editAble && canFullEdit">
                                    <el-select filterable size="small" style="width:100%" v-model="workOrderInfo.handleUserId" placeholder="请先完成质量问题信息">
                                        <el-option v-for="item in responsibleOptions" :key="item.responsibleUserId" :label="userNameById(item.responsibleUserId)" :value="item.responsibleUserId" />
                                    </el-select>
                                    <div class="field-tip">由商品温层、产品线和工厂匹配质量路由；存在多个匹配人时，从路由结果中确认。</div>
                                </template>
                                <template v-else>
                                    <el-tag v-if="isOfflineRefundIssue" type="info">不适用</el-tag>
                                    <el-tag v-else-if="workOrderInfo.handleUserId" type="success">{{userNameById(workOrderInfo.handleUserId)}}</el-tag>
                                    <span v-else class="route-warning">请先完成问题分类信息</span>
                                    <div v-if="isOfflineRefundIssue" class="field-tip">线下打款直接进入赔付流程，由系统配置的赔付专员处理。</div>
                                    <div v-else class="field-tip">根据售后问题及质量/店铺路由自动带出，仅用于接收消息，不参与工单流转和操作权限。</div>
                                </template>
                                <div v-if="workOrderInfo.handleUserEmail" class="field-tip">邮箱：{{workOrderInfo.handleUserEmail}}</div>
                            </el-descriptions-item>
                            <el-descriptions-item :span="2">
                                <template slot="label">
                                    <span style="color: #e50011">*</span> 售后问题描述
                                </template>
                                <el-input type="textarea" style="width: 100%" :disabled="!editAble?true:false" size="small" v-model="workOrderInfo.workOrderDesc" placeholder="请输入售后问题描述" />
                            </el-descriptions-item>
                            <el-descriptions-item label="图片" :span="2">
                                <el-alert
                                    v-if="isQualityIssue"
                                    class="picture-requirement"
                                    :title="pictureRequirementText"
                                    :type="missingPictureWarning ? 'warning' : 'success'"
                                    :closable="false"
                                    show-icon>
                                </el-alert>
                                <div class="picture-upload-row" v-if="editAble && canFullEdit">
                                    <el-select v-model="newPictureCategory" size="small" style="width: 130px">
                                        <el-option
                                            v-for="item in pictureCategoryOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <div tabindex="0" @paste="pasteImgFun" class="paste-wrap">点击后粘贴</div>
                                    <span>或</span>
                                    <el-upload
                                        :show-file-list="false"
                                        multiple
                                        class="upload-demo"
                                        :action="''"
                                        :httpRequest="(file)=>uploadFile(file,'order')"
                                        :file-list="fileList">
                                        <el-button size="small" type="primary" :loading="uploadingCount > 0">本地上传</el-button>
                                    </el-upload>
                                </div>

                                <div class="picture-list">
                                    <div
                                        v-for="(item,index) in workOrderInfo.workOrderPics||[]"
                                        :key="item.picUrl + '-' + index"
                                        class="picture-item">
                                        <el-image
                                            :src="item.picUrl"
                                            class="picture-image"
                                            :preview-src-list="workOrderPictureUrls">
                                        </el-image>
                                        <el-tag size="mini">{{pictureCategoryText(item.picCategory)}}</el-tag>
                                        <el-button
                                            v-if="editAble"
                                            class="picture-delete"
                                            type="danger"
                                            icon="el-icon-delete"
                                            circle
                                            size="mini"
                                            title="删除图片"
                                            @click="removeWorkOrderPic(index)">
                                        </el-button>
                                    </div>
                                </div>

                            </el-descriptions-item>
                        </el-descriptions>

                        <section v-if="workOrderInfo.workOrderProductList.length>0" class="after-sales-product-section" aria-labelledby="after-sales-product-title">
                            <el-alert
                                id="after-sales-product-title"
                                class="after-sales-product-heading"
                                title="售后商品（已勾选的是需要售后的商品）"
                                type="success"
                                :closable="false">
                            </el-alert>
                            <div class="after-sales-product-table-wrap">
                                <el-table ref="salesProTable" border :data="workOrderInfo.workOrderProductList"
                                          style="width: 100%"
                                          size="mini"
                                          @selection-change="handleSelectionChange"
                                >
                                    <el-table-column
                                        :selectable="()=>editAble && canFullEdit"
                                        type="selection"
                                        width="40">
                                    </el-table-column>
                                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                                    <el-table-column prop="barCode" label="69码"></el-table-column>
                                    <el-table-column prop="productCode" label="物品编码"></el-table-column>
                                    <el-table-column label="商品名称" min-width="280">
                                        <template slot-scope="scope">
                                            <div>{{scope.row.productName}}</div>
                                            <div v-if="scope.row.onlineProductName" style="color:#e6a23c;font-size:12px;line-height:20px;">
                                                套装名：{{scope.row.onlineProductName}}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="发货仓">
                                        <template slot-scope="scope">
                                            {{scope.row.dispatchStoreName || scope.row.factoryName || '-'}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="pici" label="批次"></el-table-column>
                                    <el-table-column label="物流">
                                        <template slot-scope="scope">
                                            {{scope.row.logisticName}}
                                            {{scope.row.wayNo?'('+scope.row.wayNo+'）':''}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="workOrderDesc" label="图片">
                                        <template slot-scope="scope">
                                            <div class="product-picture-list">
                                                <div
                                                    v-for="(item,index) in scope.row.picList||[]"
                                                    :key="item + '-' + index"
                                                    class="product-picture-item">
                                                    <el-image
                                                        :src="item"
                                                        class="product-picture-image"
                                                        :preview-src-list="scope.row.picList">
                                                    </el-image>
                                                    <el-button
                                                        v-if="editAble"
                                                        class="product-picture-delete"
                                                        type="danger"
                                                        icon="el-icon-delete"
                                                        circle
                                                        size="mini"
                                                        title="删除图片"
                                                        @click="removeProductPic(scope.row,index)">
                                                    </el-button>
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column width="250" v-if="editAble && canFullEdit" prop="workOrderDesc" label="操作">
                                        <template slot-scope="scope">
                                            <div style="display: flex;align-items: center">
                                                <div tabindex="0" @paste="(event)=>pasteImgFun(event,scope.row)" class="paste-wrap">点击后粘贴</div>

                                                <span style="margin: 0 10px">或 </span>
                                                <el-upload
                                                    :show-file-list="false"
                                                    multiple
                                                    class="upload-demo"
                                                    :action="''"
                                                    :httpRequest="(file)=>uploadFile(file,scope.row)"
                                                    :file-list="fileList">
                                                    <el-button size="mini" plain type="primary" :loading="uploadingCount > 0">本地上传</el-button>
                                                </el-upload>
                                            </div>

                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </section>

                        <div class="form-section-heading">
                            <span class="form-section-index">4</span>
                            <div>
                                <div class="form-section-title">处理方案</div>
                                <div class="form-section-description">处理结果决定后续流向；仅展示当前选择需要补充的字段。</div>
                            </div>
                        </div>
                        <el-tabs v-if="canFullEdit || hasSubmittedHandlePlan" v-model="selectedHandleMode" type="border-card" class="result-mode-tabs margin-top">
                            <el-tab-pane
                                v-for="mode in handleModeOptions"
                                :key="mode.value"
                                :label="mode.label"
                                :name="mode.value"
                                :disabled="!canFullEdit || (isOfflineRefundIssue && mode.value !== 'COMPENSATION')">
                                <div class="result-mode-tip">
                                    {{mode.value === 'COMPENSATION' && isOfflineRefundIssue ? '线下打款固定进入赔付流程，提交后由赔付专员处理。' : mode.tip}}
                                </div>
                                <div v-if="isOfflineRefundIssue" class="field-tip result-mode-lock-tip"><i class="el-icon-lock"></i>线下打款固定为赔付，其他处理结果不可选择。</div>
                                <el-descriptions class="result-mode-form" :label-style="labelStyle" :column="columnsCount" size="small" border>
                                    <el-descriptions-item label="处理说明" :span="mode.value === 'UPGRADE' ? 1 : 2">
                                        <template slot="label">处理说明</template>
                                        <el-input v-model="workflowForms.handleResult.communicationResult" :disabled="!editAble || !canFullEdit" type="textarea" :rows="2" maxlength="1000" show-word-limit placeholder="请填写与客户确认的处理结果"></el-input>
                                    </el-descriptions-item>
                                    <el-descriptions-item v-if="mode.value === 'UPGRADE' && !isOfflineRefundIssue" label="客诉专员">
                                        <template slot="label"><span style="color: #e50011">*</span> 客诉专员</template>
                                        <el-select v-model="workflowForms.handleResult.upgradeHandlerUserId" :disabled="!editAble || !canFullEdit" filterable size="small" placeholder="请选择客诉专员" style="width:100%">
                                            <el-option v-for="item in complaintSpecialistOptions" :key="item.userId" :label="item.userName || item.userId" :value="item.userId"></el-option>
                                        </el-select>
                                    </el-descriptions-item>
                                    <template v-if="mode.value === 'COMPENSATION'">
                                        <el-descriptions-item label="申请金额">
                                            <template slot="label"><span style="color: #e50011">*</span> 申请金额</template>
                                            <el-input-number v-model="offlinePayment.requestedAmount" :disabled="!editAble || !canFullEdit" :min="0.01" :precision="2" size="small" style="width: 180px"></el-input-number>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="收款人">
                                            <template slot="label"><span style="color: #e50011">*</span> 收款人</template>
                                            <el-input v-if="canFullEdit" size="small" v-model="offlinePayment.payeeName" :disabled="!editAble" placeholder="请输入收款人"></el-input>
                                            <span v-else>{{(workflowDetail.payment && workflowDetail.payment.payeeName) || offlinePayment.payeeName || '-'}}</span>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="收款账号">
                                            <template slot="label"><span style="color: #e50011">*</span> 收款账号</template>
                                            <el-input v-if="canFullEdit" size="small" v-model="offlinePayment.payeeAccount" :disabled="!editAble" placeholder="请输入收款账号"></el-input>
                                            <span v-else>{{(workflowDetail.payment && (workflowDetail.payment.payeeAccount || workflowDetail.payment.payeeAccountMask)) || offlinePayment.payeeAccount || '-'}}</span>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="打款处理人">
                                            <el-tag type="warning">赔付专员（系统配置）</el-tag>
                                            <div class="field-tip">提交工单后自动生成待打款申请并流转给当前配置的赔付专员；提交前不会流转。</div>
                                        </el-descriptions-item>
                                    </template>
                                    <el-descriptions-item label="预计流转" :span="2">
                                        <div class="flow-preview"><i class="el-icon-guide"></i> {{createFlowPreviewText}}</div>
                                    </el-descriptions-item>
                                </el-descriptions>
                            </el-tab-pane>
                        </el-tabs>
                        <div v-if="editAble && canFullEdit" class="work-order-submit-actions">
                            <el-button
                                class="work-order-submit-button"
                                type="primary"
                                :loading="saving"
                                :disabled="uploadingCount > 0"
                                @click="submitWorkOrder">
                                {{uploadingCount > 0 ? '图片上传中' : '提交工单'}}
                            </el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="ORDER_INFO">
                        <span
                            slot="label"
                            class="order-info-tab-label"
                            :class="{'order-info-tab-label--attention': orderInfoTabAttention && hasOrderDetail}">
                            <span>订单信息</span>
                            <span v-if="hasOrderDetail" class="order-info-tab-status" role="status" aria-live="polite">
                                <i class="el-icon-success" aria-hidden="true"></i>
                                已获取
                            </span>
                        </span>
                        <template v-if="Object.keys(orderDetailInfo).length > 0">
                            <el-alert style="margin: 20px 0 10px 0"
                                      title="基本信息"
                                      type="success"
                                      :closable="false">
                            </el-alert>
                            <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>
                                <el-descriptions-item label="店铺">
                                    {{orderDetailInfo.shopName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="微信主单号">
                                    {{orderDetailInfo.orderMainNo}}
                                </el-descriptions-item>
                                <el-descriptions-item label="子单号/外部订单号">
                                    {{orderDetailInfo.orderNo}}
                                </el-descriptions-item>
                                <el-descriptions-item label="订单状态">
                                    {{orderDetailInfo.orderStatusName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="订单类型">
                                    {{orderDetailInfo.orderTypeName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="订单分类">
                                    {{orderDetailInfo.orderSonTypeName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="冷链/常温">
                                    {{orderDetailInfo.orderIsCwName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="是否流转">
                                    {{orderDetailInfo.orderFlowSignName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="流转异常原因">
                                    {{orderDetailInfo.flowErroMessage}}
                                </el-descriptions-item>
                                <el-descriptions-item label="是否挂起">
                                    {{orderDetailInfo.isPending == 1 ? '是' : '否'}}
                                </el-descriptions-item>
                                <el-descriptions-item label="微信订单来源">
                                    {{orderDetailInfo.orderSourceName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="微信来源主单号">
                                    {{orderDetailInfo.sourceOrderMainNo}}
                                </el-descriptions-item>
                                <el-descriptions-item label="微信订单分类">
                                    {{orderDetailInfo.orderClassName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="购买人昵称">
                                    <p v-if="isWeixinOrder && orderDetailInfo.buyerId != 'csms-manual-order-creator'" @click="toBuyer(orderDetailInfo.buyerId)" style="text-decoration:underline;color:#0000ff;">{{orderDetailInfo.buyerName}}</p>
                                    <p v-if="!(isWeixinOrder && orderDetailInfo.buyerId != 'csms-manual-order-creator')">{{orderDetailInfo.buyerName}}</p>
                                </el-descriptions-item>
                                <el-descriptions-item label="支付时间">
                                    {{orderDetailInfo.payTime}}
                                </el-descriptions-item>
                                <el-descriptions-item label="备注">
                                    {{orderDetailInfo.remark}}
                                </el-descriptions-item>
                            </el-descriptions>
                            <el-alert style="margin: 20px 0 10px 0"
                                      title="支付信息"
                                      type="success"
                                      :closable="false">
                            </el-alert>
                            <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>
                                <el-descriptions-item label="订单金额">
                                    {{orderDetailInfo.orderAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="运费">
                                    {{orderDetailInfo.freight}}
                                </el-descriptions-item>
                                <el-descriptions-item v-if="this.isWeixinOrder" label="现金支付">
                                    {{orderDetailInfo.cashAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item v-if="!this.isWeixinOrder" label="支付金额">
                                    {{orderDetailInfo.payAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="优惠券">
                                    {{orderDetailInfo.orderCouponAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="奶卡支付金额" :span="3">
                                    <template v-if="orderDetailInfo.specialCardPayDetails && orderDetailInfo.specialCardPayDetails.length > 0">
                                        <div class="special-card-pay-list">
                                            <el-tag
                                                v-for="item in orderDetailInfo.specialCardPayDetails"
                                                :key="item.cardNo"
                                                type="success"
                                                size="mini"
                                            >
                                                奶卡号{{item.cardNo}}：{{formatAmount(item.payAmount)}}
                                            </el-tag>
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{formatAmount(orderDetailInfo.specialCardPoint)}}
                                    </template>
                                </el-descriptions-item>
                                <el-descriptions-item label="余额支付总额" :span="3">
                                    {{orderDetailInfo.balanceAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="余额储值部分">
                                    {{orderDetailInfo.balanceStoreAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="余额赠送部分">
                                    {{orderDetailInfo.balanceFreeAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="余额礼品卡部分">
                                    {{orderDetailInfo.balanceGiftAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="微信交易号">
                                    {{orderDetailInfo.wechatPaySerialNo}}
                                </el-descriptions-item>
                                <el-descriptions-item label="商户单号">
                                    {{orderDetailInfo.wechatPayTradeNo}}
                                </el-descriptions-item>
                            </el-descriptions>
                            <el-alert style="margin: 20px 0 10px 0"
                                      title="配送信息"
                                      type="success"
                                      :closable="false">
                            </el-alert>
                            <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>
                                <el-descriptions-item label="提货日期">
                                    {{orderDetailInfo.pickupDate}}
                                </el-descriptions-item>
                                <el-descriptions-item label="配送日期">
                                    {{orderDetailInfo.deliverDate}}
                                </el-descriptions-item>
                                <el-descriptions-item label="发货仓">
                                    {{orderDetailInfo.storeName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="收货人">
                                    {{orderDetailInfo.consigneeName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="收货电话">
                                    {{orderDetailInfo.consigneePhone}}
                                </el-descriptions-item>
                                <el-descriptions-item label="详细地址">
                                    {{orderDetailInfo.consigneeAddrEntire}}
                                </el-descriptions-item>
                                <el-descriptions-item label="物流公司">
                                    {{orderDetailInfo.wayName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="物流单号">
                                    {{orderDetailInfo.wayNo}}
                                </el-descriptions-item>
                                <el-descriptions-item v-if="orderDetailInfo.wayNo != null && orderDetailInfo.wayNo != ''" label="物流信息">
                                    <el-timeline>
                                        <el-timeline-item
                                            v-for="(activity, index) in routers"
                                            :key="index"
                                            :timestamp="activity.time">
                                            {{activity.context}}
                                        </el-timeline-item>
                                    </el-timeline>
                                </el-descriptions-item>
                            </el-descriptions>
                            <el-alert style="margin: 20px 0 10px 0"
                                      title="退款记录"
                                      type="success"
                                      :closable="false">
                            </el-alert>
                            <el-table size="mini" :data="orderDetailInfo.orderRefundDetails" style="width: 100%">
                                <el-table-column prop="refundNo" label="退款单号" width="180"></el-table-column>
                                <el-table-column prop="refundType" label="退款类型" width="180"></el-table-column>
                                <el-table-column prop="afterSaleType" label="售后类型"></el-table-column>
                                <el-table-column prop="refundAmountCheck" label="退款金额"></el-table-column>
                                <el-table-column prop="refundStatus" label="状态"></el-table-column>
                                <el-table-column prop="refundReason" label="原因"></el-table-column>
                                <el-table-column prop="createId" label="操作人"></el-table-column>
                                <el-table-column prop="createTime" label="申请时间"></el-table-column>
                            </el-table>
                        </template>
                        <el-empty v-else :image-size="200" description="暂无订单信息"></el-empty>
                    </el-tab-pane>
                    <el-tab-pane
                        v-for="module in workflowModuleTabs"
                        :key="module.code"
                        :label="module.label"
                        :name="module.code"
                        lazy>
                        <div v-loading="workflowLoading" class="workflow-panel">
                            <el-alert v-if="isPaymentSpecialistStage && module.code !== 'PAYMENT'"
                                      title="只读查看"
                                      description="当前处于赔付处理阶段；赔付专员只能在“赔付处理”页签操作，其他页签仅供查看。"
                                      type="info"
                                      :closable="false"
                                      show-icon
                                      class="workflow-card"></el-alert>
                            <el-alert v-if="Number(workOrderInfo.workOrderStatus) === 10" title="工单已关闭" description="已关闭在本流程中表示工单业务完结；历史信息、日志和附件仍可查看。" type="success" :closable="false" show-icon class="workflow-card"></el-alert>
                            <el-alert v-else-if="isOfflineRefundIssue" title="线下打款流程" description="客服先登记金额和收款信息；赔付专员完成打款并上传凭证后直接关单，无需责任划分。" type="warning" :closable="false" show-icon class="workflow-card"></el-alert>
                            <el-card v-if="module.code === 'COMPLAINT'" shadow="never" class="workflow-card"><div slot="header">升级处理<el-button v-if="canTransferComplaint" type="text" size="mini" style="float:right" @click="openComplaintTransfer">转交</el-button></div>
                                <el-form v-if="workflowEdit.complaint" :model="workflowForms.complaint" label-width="90px" size="mini" class="workflow-form">
                                    <el-form-item label="最终处理" required><el-input type="textarea" :rows="3" v-model="workflowForms.complaint.finalHandleText"/></el-form-item>
                                    <el-form-item label="是否赔付" required><el-radio-group v-model="workflowForms.complaint.paymentRequired" :disabled="!!workflowForms.complaint.complaintId"><el-radio :label="true">转赔付</el-radio><el-radio :label="false">无需赔付，直接关单</el-radio></el-radio-group></el-form-item>
                                    <template v-if="workflowForms.complaint.paymentRequired"><el-form-item label="申请金额" required><el-input-number v-model="workflowForms.complaint.requestedAmount" :min="0.01" :precision="2"/></el-form-item><el-form-item label="打款处理人"><el-input :value="configuredPaymentSpecialistName" disabled style="width:220px"/></el-form-item><el-form-item label="收款人" required><el-input v-model="workflowForms.complaint.payeeName" style="width:220px"/></el-form-item><el-form-item label="收款账号" required><el-input v-model="workflowForms.complaint.payeeAccount" style="width:260px"/></el-form-item></template>
                                    <el-form-item label="附件图片">
                                        <el-upload action="#" :show-file-list="false" :http-request="uploadComplaintImage" accept="image/*" :disabled="!workflowCanAttach">
                                            <el-button size="mini" type="primary" plain :disabled="!workflowCanAttach">上传附件图片</el-button>
                                        </el-upload>
                                        <div v-if="workflowCanAttach" tabindex="0" class="workflow-payment-paste" @paste="pasteComplaintImage">点击此处后粘贴图片（Ctrl/⌘+V）</div>
                                        <div class="workflow-attachment-hint">选填，支持上传或直接粘贴图片</div>
                                        <div v-if="complaintImageAttachments.length" class="workflow-attachment-list">
                                            <div v-for="(item,index) in complaintImageAttachments" :key="item.id" class="workflow-attachment-item workflow-attachment-item--removable">
                                                <el-image :src="item.url" :preview-src-list="complaintImageAttachments.map(file => file.url)" fit="cover"/>
                                                <span>{{item.name}}</span>
                                                <el-button v-if="workflowCanAttach" type="danger" icon="el-icon-delete" circle size="mini" class="workflow-attachment-remove" :aria-label="'删除附件图片' + (index + 1)" @click.stop="removeComplaintImage(item)"/>
                                            </div>
                                        </div>
                                    </el-form-item>
                                    <el-button type="primary" size="mini" :loading="workflowSaving.complaint" :disabled="!workflowEdit.complaint" @click="submitWorkflowComplaint">{{workflowForms.complaint.complaintId ? '保存补录' : '提交客诉处理'}}</el-button>
                                </el-form>
                                <el-descriptions v-if="workflowDetail.complaint" :column="columnsCount" size="small" border>
                                    <el-descriptions-item label="处理结论"><span class="pre-line-text">{{workflowDetail.complaint.finalHandleText || '-'}}</span></el-descriptions-item>
                                    <el-descriptions-item label="打款要求">{{workflowDetail.complaint.paymentRequired ? '需要打款' : '无需打款'}}</el-descriptions-item>
                                    <el-descriptions-item label="收款人">{{workflowDetail.complaint.payeeName || '-'}}</el-descriptions-item>
                                    <el-descriptions-item label="收款账户">{{workflowDetail.complaint.payeeAccount || workflowDetail.complaint.payeeAccountMask || '-'}}</el-descriptions-item>
                                    <el-descriptions-item label="附件图片" :span="columnsCount">
                                        <div v-if="complaintImageAttachments.length" class="workflow-attachment-list">
                                            <div v-for="item in complaintImageAttachments" :key="'summary-' + item.id" class="workflow-attachment-item">
                                                <el-image :src="item.url" :preview-src-list="complaintImageAttachments.map(file => file.url)" fit="cover"/>
                                                <span>{{item.name}}</span>
                                            </div>
                                        </div>
                                        <span v-else>-</span>
                                    </el-descriptions-item>
                                </el-descriptions><el-empty v-else description="暂无客诉处理记录" :image-size="60"></el-empty>
                                <el-dialog title="转交升级处理" :visible.sync="complaintTransfer.visible" width="420px" append-to-body :close-on-click-modal="false">
                                    <el-form label-width="90px" size="small">
                                        <el-form-item label="接收人" required>
                                            <el-select v-model="complaintTransfer.targetUserId" filterable placeholder="请选择客诉专员" style="width:100%">
                                                <el-option v-for="user in transferableComplaintSpecialists" :key="user.userId" :label="user.userName" :value="user.userId"/>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="转交说明">
                                            <el-input v-model="complaintTransfer.remark" type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="选填，可说明当前处理进度"/>
                                        </el-form-item>
                                    </el-form>
                                    <div slot="footer">
                                        <el-button size="mini" @click="complaintTransfer.visible = false">取消</el-button>
                                        <el-button type="primary" size="mini" :loading="workflowSaving.complaintTransfer" @click="submitComplaintTransfer">确认转交</el-button>
                                    </div>
                                </el-dialog>
                            </el-card>
                            <el-card v-if="showPaymentWorkflowCard && (module.code === 'PAYMENT' || module.code === 'RESPONSIBILITY')" shadow="never" class="workflow-card"><div slot="header">{{module.code === 'RESPONSIBILITY' ? '责任确认' : (isOfflineRefundIssue ? '线下打款' : '赔付处理')}}</div>
                                <el-descriptions v-if="module.code === 'PAYMENT' && workflowDetail.payment" :column="columnsCount" size="small" border class="workflow-summary-table">
                                    <el-descriptions-item label="是否打款">{{paymentStatusText(workflowDetail.payment.paymentStatus)}}</el-descriptions-item>
                                    <el-descriptions-item label="申请金额">{{formatAmount(workflowDetail.payment.requestedAmount)}}</el-descriptions-item>
                                    <el-descriptions-item label="实际金额">{{formatAmount(workflowDetail.payment.actualAmount)}}</el-descriptions-item>
                                    <el-descriptions-item label="收款人">{{workflowDetail.payment.payeeName || '-'}}</el-descriptions-item>
                                    <el-descriptions-item label="收款账户">{{workflowDetail.payment.payeeAccount || workflowDetail.payment.payeeAccountMask || '-'}}</el-descriptions-item>
                                    <template v-if="isOfflineRefundIssue">
                                        <el-descriptions-item label="责任划分" :span="columnsCount">无需责任划分</el-descriptions-item>
                                    </template>
                                    <template v-else>
                                        <el-descriptions-item label="初步责任状态">{{(workflowDetail.responsibility && workflowDetail.responsibility.responsibilityStatus) || '暂无'}}</el-descriptions-item>
                                        <el-descriptions-item label="初步责任" :span="columnsCount"><span v-if="(workflowDetail.responsibilityItems || []).length">{{workflowDetail.responsibilityItems.map(item => item.optionName || item.customText || item.ownerType).join('、')}}</span><span v-else>暂无</span></el-descriptions-item>
                                    </template>
                                    <el-descriptions-item v-if="!workflowEdit.paymentComplete" label="打款凭证" :span="columnsCount">
                                        <div v-if="paymentVoucherAttachments.length" class="workflow-attachment-list">
                                            <div v-for="item in paymentVoucherAttachments" :key="'payment-summary-' + item.id" class="workflow-attachment-item">
                                                <el-image :src="item.url" :preview-src-list="paymentVoucherAttachments.map(file => file.url)" fit="cover"/>
                                                <span>{{item.name}}</span>
                                            </div>
                                        </div>
                                        <span v-else>-</span>
                                    </el-descriptions-item>
                                </el-descriptions>
                                <el-form v-if="module.code === 'PAYMENT' && workflowEdit.payment && !workflowEdit.paymentComplete" :model="workflowForms.payment" label-width="90px" size="mini" class="workflow-form"><el-form-item label="申请金额" required><el-input-number v-model="workflowForms.payment.requestedAmount" :min="0.01" :precision="2"/></el-form-item><el-form-item label="收款人" required><el-input v-model="workflowForms.payment.payeeName" :placeholder="workflowForms.payment.paymentId ? '不修改可留空' : ''" style="width:220px"/></el-form-item><el-form-item label="收款账号" required><el-input v-model="workflowForms.payment.payeeAccount" :placeholder="workflowForms.payment.paymentId ? '不修改可留空' : ''" style="width:260px"/></el-form-item><el-form-item label="打款处理人"><el-input :value="configuredPaymentSpecialistName" disabled style="width:220px"/></el-form-item><el-form-item label="状态"><el-input value="待打款" disabled style="width:150px"/></el-form-item><el-button type="primary" size="mini" :loading="workflowSaving.payment" @click="submitWorkflowPayment">保存打款申请</el-button></el-form>
                                <el-form v-if="module.code === 'PAYMENT' && workflowEdit.paymentComplete" :model="workflowForms.payment" label-width="90px" size="mini" class="workflow-form">
                                    <el-alert title="赔付专员处理" :description="isOfflineRefundIssue ? '已打款需填写实际金额并上传凭证，提交后直接关闭工单，无需责任划分。' : '已打款需上传凭证并提交初步责任；公司承担或无需打款将直接关闭，供应商承担进入责任确认。'" type="info" :closable="false" show-icon class="workflow-inline-alert"></el-alert>
                                    <el-form-item label="是否打款" required>
                                        <el-radio-group v-model="workflowForms.payment.completionStatus">
                                            <el-radio label="COMPLETED">已打款</el-radio>
                                            <el-radio label="NOT_REQUIRED">无需打款</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <template v-if="workflowForms.payment.completionStatus === 'COMPLETED'">
                                        <el-form-item label="实际金额" required><el-input-number v-model="workflowForms.payment.actualAmount" :min="0.01" :precision="2"/></el-form-item>
                                        <el-form-item label="打款凭证" required>
                                            <el-upload action="#" :show-file-list="false" :http-request="uploadPaymentVoucher" accept="image/*">
                                                <el-button size="mini" type="primary" plain>上传打款截图</el-button>
                                            </el-upload>
                                            <div tabindex="0" class="workflow-payment-paste" @paste="pastePaymentVoucher">点击此处后粘贴截图（Ctrl/⌘+V）</div>
                                            <div v-if="paymentVoucherAttachments.length" class="workflow-attachment-list">
                                                <div v-for="(item,index) in paymentVoucherAttachments" :key="item.id" class="workflow-attachment-item workflow-attachment-item--removable">
                                                    <el-image :src="item.url" :preview-src-list="paymentVoucherAttachments.map(file => file.url)" fit="cover"/>
                                                    <span>{{item.name}}</span>
                                                    <el-button type="danger" icon="el-icon-delete" circle size="mini" class="workflow-attachment-remove" :aria-label="'删除打款凭证' + (index + 1)" @click.stop="removePaymentVoucher(item)"/>
                                                </div>
                                            </div>
                                        </el-form-item>
                                        <el-form-item v-if="!isOfflineRefundIssue" label="初步责任" required class="responsibility-form-item">
                                            <div class="responsibility-single-choice-hint">公司承担与供应商承担合计单选，只能选择一项</div>
                                            <el-radio-group v-model="workflowForms.responsibility.selectionKey" class="responsibility-global-group">
                                                <div class="responsibility-allocation">
                                                    <div v-for="group in responsibilityGroups" :key="group.ownerType" class="responsibility-card">
                                                        <div class="responsibility-card__title">{{group.label}}</div>
                                                        <div class="responsibility-options">
                                                            <el-radio v-for="option in group.options" :key="option.code" :label="responsibilityOptionValue(group,option)">{{option.name}}</el-radio>
                                                        </div>
                                                        <el-input v-if="isResponsibilityOptionSelected(group,'OTHER')" v-model="workflowForms.responsibility[group.customKey]" maxlength="100" show-word-limit :placeholder="'请输入' + group.label + '的其他责任内容'" class="responsibility-other-input"/>
                                                    </div>
                                                </div>
                                            </el-radio-group>
                                        </el-form-item>
                                    </template>
                                    <div class="workflow-primary-action">
                                        <el-button type="success" size="medium" class="workflow-primary-submit" :loading="workflowSaving.paymentComplete" @click="completeWorkflowPayment">{{paymentCompleteButtonText}}</el-button>
                                    </div>
                                </el-form>
                                <el-form v-if="module.code === 'RESPONSIBILITY' && workflowDetail.responsibility" :model="workflowForms.responsibility" label-width="90px" size="mini" class="workflow-form">
                                    <el-form-item label="责任划分" required class="responsibility-form-item">
                                        <div class="responsibility-single-choice-hint">公司承担与供应商承担合计单选，只能选择一项</div>
                                        <el-radio-group v-model="workflowForms.responsibility.selectionKey" class="responsibility-global-group" :disabled="!workflowEdit.responsibilityFinal">
                                            <div class="responsibility-allocation">
                                                <div v-for="group in responsibilityGroups" :key="group.ownerType" class="responsibility-card">
                                                    <div class="responsibility-card__title">{{group.label}}</div>
                                                    <div class="responsibility-options">
                                                        <el-radio v-for="option in group.options" :key="option.code" :label="responsibilityOptionValue(group,option)">{{option.name}}</el-radio>
                                                    </div>
                                                    <el-input v-if="isResponsibilityOptionSelected(group,'OTHER')" v-model="workflowForms.responsibility[group.customKey]" maxlength="100" show-word-limit :disabled="!workflowEdit.responsibilityFinal" :placeholder="'请输入' + group.label + '的其他责任内容'" class="responsibility-other-input"/>
                                                </div>
                                            </div>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="确认说明" required>
                                        <el-input v-model="workflowForms.responsibility.confirmRemark" type="textarea" :rows="3" maxlength="500" show-word-limit :disabled="!workflowEdit.responsibilityFinal" placeholder="请输入最终责任确认说明"/>
                                    </el-form-item>
                                    <div class="workflow-primary-action"><el-button v-if="workflowEdit.responsibilityFinal && workflowDetail.responsibility.responsibilityStatus === 'SUBMITTED'" type="success" size="medium" class="workflow-primary-submit" :loading="workflowSaving.responsibilityFinal" @click="submitWorkflowResponsibility">确认最终责任</el-button></div>
                                </el-form>
                            </el-card>
                            <el-card v-if="module.code === 'PROCESS_LOG'" shadow="never" class="workflow-card workflow-log-card"><div slot="header">处理日志</div>
                                <el-timeline v-if="processTimelineItems.length" class="workflow-timeline">
                                    <el-timeline-item v-for="item in processTimelineItems" :key="item.timelineKey" :timestamp="item.createTime" :type="workflowAuditType(item)" placement="top">
                                        <div class="audit-entry">
                                            <div class="audit-entry__header">
                                                <span class="audit-entry__title">{{workflowAuditTitle(item)}}</span>
                                                <span class="audit-entry__operator">{{workflowAuditOperator(item)}}</span>
                                            </div>
                                            <div v-if="auditChangeRows(item).length" class="audit-change-list">
                                                <div v-for="row in auditChangeRows(item)" :key="row.key" class="audit-change-row">
                                                    <span class="audit-change-row__label">{{row.label}}</span>
                                                    <span v-if="row.hasBefore && row.hasAfter && row.before !== row.after" class="audit-change-row__value">
                                                        <span class="audit-change-row__before">{{row.before}}</span>
                                                        <i class="el-icon-right audit-change-row__arrow"></i>
                                                        <span>{{row.after}}</span>
                                                    </span>
                                                    <span v-else class="audit-change-row__value">{{row.hasAfter ? row.after : row.before}}</span>
                                                </div>
                                            </div>
                                            <div v-if="item.attachments && item.attachments.length" class="audit-attachment-section">
                                                <div class="audit-attachment-section__title"><i class="el-icon-paperclip"></i> 附件</div>
                                                <div class="workflow-attachment-list audit-attachment-list">
                                                    <div v-for="attachment in item.attachments" :key="attachment.id" class="workflow-attachment-item">
                                                        <el-image :src="attachment.url" :preview-src-list="item.attachments.map(file => file.url)" fit="cover"/>
                                                        <span :title="attachment.name">{{attachment.name}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </el-timeline-item>
                                </el-timeline>
                                <el-empty v-else description="暂无处理日志" :image-size="60"></el-empty>
                            </el-card>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </defaultSec>
</template>

<script>
    import defaultSec from '@c/defaultSection'
    export default {
        data() {
            return {
                loading:false,
                resourceUrl: process.env.VUE_APP_API_PATH,
                orderDetailInfo:{},
                workOrderInfo:{
                    orderOnline:1,
                    temperatureZone:'UNKNOWN',
                    temperatureZoneOriginal:'',
                    createUserName:'',
                    handleUserName:'',
                    handleUserEmail:'',
                    responsibleDeptName:'',
                    communicationStatus:'NO_REPLY_REQUIRED',
                    communicationResult:'',
                    productionQuestion:'',
                    productionReply:'',
                    qualityReturnTrackingNo:'',
                    workOrderPics:[],
                    workOrderProductList:[],
                    workOrderFlowList:[],
                },
                workflowDetail:{handleResult:null,complaint:null,payment:null,responsibility:null,responsibilityItems:[],auditLogs:[],nodes:[],capabilities:{}},
                detailActiveTab:'BASIC_INFO',
                orderInfoTabAttention:false,
                orderInfoAttentionTimer:null,
                workflowActiveModule:'COMPLAINT',
                workflowLoading:false,
                workflowAttachments:[], workflowAttachmentCategory:'COMPLAINT_IMAGE',
                workflowCanAttach:false,
                workflowEdit:{handleResult:false,complaint:false,payment:false,paymentComplete:false,responsibilityFinal:false},
                workflowSaving:{handleResult:false,complaint:false,complaintTransfer:false,payment:false,paymentComplete:false,responsibilityFinal:false},
                complaintTransfer:{visible:false,targetUserId:'',remark:''},
                physicalDeleting:false,
                workflowForms:{
                    handleResult:{resultId:null,handleMode:'',upgradeHandlerUserId:'',communicationResult:'',returnTrackingNo:'',version:0,recordVersion:0},
                    complaint:{complaintId:null,finalHandleText:'',paymentRequired:false,requestedAmount:null,payeeAccount:'',payeeName:'',version:0,recordVersion:0},
                    payment:{paymentId:null,paymentStatus:'PENDING',completionStatus:'',requestedAmount:null,actualAmount:null,payeeAccount:'',payeeName:'',version:0,recordVersion:0},
                    responsibility:{responsibilityId:null,items:[],selectionKey:'',companyCustomText:'',supplierCustomText:'',confirmRemark:'',finalNodeVersion:0,responsibilityVersion:0}
                },
                responsibilityGroups:[
                    {ownerType:'COMPANY',label:'公司承担',customKey:'companyCustomText',options:[{code:'SUPPLY_CHAIN',name:'供应链'},{code:'USER_EXPERIENCE',name:'用户体验'},{code:'PROFESSIONAL_CLAIMANT',name:'职业理赔人'},{code:'R_AND_D',name:'研发'},{code:'OPERATION',name:'运营'},{code:'OTHER',name:'其他'}]},
                    {ownerType:'SUPPLIER',label:'供应商承担',customKey:'supplierCustomText',options:[{code:'XIJIANG',name:'西江'},{code:'TIANCHEN',name:'天辰'},{code:'LAIMU',name:'莱牧'},{code:'ANMU',name:'安牧'},{code:'DONGJUN',name:'东君'},{code:'COLD_CHAIN_LOGISTICS',name:'低温物流'},{code:'OTHER',name:'其他'}]}
                ],
                offlineProduct:{cguid:'',productName:'',productCode:'',barCode:'',pici:''},
                offlineProductOptions:[],
                offlineProductLoading:false,
                offlinePayment:{requestedAmount:null,payeeName:'',payeeAccount:''},
                workOrderNo: this.$route.params.id,
                classificationMode:String(this.$route.params.id) === '0' ? 'stable' : 'legacy',
                userList:[],
                deptList:[],
                issueOptions:[],
                handleModeOptions:[
                    {value:'REISSUE',label:'补发',tip:'提交后自动关闭工单。'},
                    {value:'REFUND',label:'退款',tip:'提交后自动关闭工单。'},
                    {value:'REISSUE_AND_REFUND',label:'补发+退款',tip:'提交后自动关闭工单。'},
                    {value:'COMPENSATION',label:'赔付',tip:'提交后进入赔付流程；赔付专员完成打款和初步责任划分后，进入责任确认。'},
                    {value:'UPGRADE',label:'升级',tip:'提交后进入客诉专员处理；客诉专员可直接关闭或转入赔付。'},
                ],
                legacyTypeOptions:[],
                productLineOptions:[],
                factoryOptions:[],
                originalStableSelection:null,
                originalRelationSelection:null,
                resolvedRelationSomeID:'',
                fileList:[],
                workOrderProductList:[],
                isWeixinOrder: true,
                editAble:String(this.$route.params.id) === '0',
                //关联类型：0无关联，1订单，2售后单，3微信客户
                relateTypeList:[
                    {key:0,title:'无关联'},
                    {key:1,title:'关联订单'},
                    {key:2,title:'关联售后单'},
                    {key:3,title:'关联微信用户'},
                ],
                logList: [],
                multipleSelProList: [],
                orderSourceList: [],
                pasteImg:"",
                saving:false,
                productionReplySaving:false,
                uploadingCount:0,
                aiInputText:'',
                aiImages:[],
                aiRecognizing:false,
                aiUploadingCount:0,
                aiWarnings:[],
                aiUnresolvedFields:[],
                aiResultVisible:false,
                aiDraftExpanded:false,
                saveRequestToken:'',
                replyRequestToken:'',
                productionReplyInput:'',
                draftStorageKey:'csms-work-order-create-draft-v1',
                draftTtlMs:2 * 60 * 60 * 1000,
                draftSaveTimer:null,
                draftReady:false,
                componentDestroyed:false,
                resizeHandler:null,
                workOrderRequestSeq:0,
                issueRequestSeq:0,
                productLineRequestSeq:0,
                factoryRequestSeq:0,
                shopRouteRequestSeq:0,
                newPictureCategory:'PRODUCT_STATUS',
                routers:[],
                pictureCategoryOptions:[
                    {value:'OUTER_PACKAGE',label:'外包装'},
                    {value:'PRODUCT_STATUS',label:'产品状态'},
                    {value:'BATCH',label:'批次'},
                    {value:'OTHER',label:'其他'},
                ],
                communicationStatusOptions:[
                    {value:'PENDING_REPLY',label:'待生产回复'},
                    {value:'REPLIED',label:'生产已回复'},
                    {value:'RESULT_AVAILABLE',label:'已有沟通结果'},
                    {value:'NO_REPLY_REQUIRED',label:'无需生产回复'},
                ],
                columnsCount:2,
                clientWidth:document.body.clientWidth,
                labelStyle:{
                    width: '100px',
                },
                // contentStyle:{
                //     width: 'calc(100% - 100px)',
                // },

            }
        },
        components:{
            defaultSec,
        },
        computed:{
            workflowModuleTabs(){
                const labels={COMPLAINT:'升级处理',PAYMENT:'赔付处理',RESPONSIBILITY:'责任确认',PROCESS_LOG:'处理日志'}
                const visible = Array.isArray(this.workflowDetail.visibleTabs) ? this.workflowDetail.visibleTabs : []
                return visible.filter(code => labels[code]).map(code => ({code:code,label:labels[code]}))
            },
            isDraftWorkOrder(){
                return String(this.workOrderNo) !== '0'
                    && Number(this.workOrderInfo.workOrderStatus) === 1
            },
            canFullEdit(){
                return String(this.workOrderNo) === '0' || this.isDraftWorkOrder
            },
            hasSubmittedHandlePlan(){
                const handleResult = this.workflowDetail.handleResult || {}
                return Boolean(handleResult.handleMode || this.workflowDetail.payment || this.isOfflineRefundIssue)
            },
            selectedHandleMode:{
                get(){
                    return this.isOfflineRefundIssue
                        ? 'COMPENSATION'
                        : this.workflowForms.handleResult.handleMode
                },
                set(value){
                    const handleMode = this.isOfflineRefundIssue ? 'COMPENSATION' : value
                    this.$set(this.workflowForms.handleResult,'handleMode',handleMode)
                },
            },
            useStableClassification(){
                return this.classificationMode === 'stable'
            },
            stableTypeCascaderOptions(){
                const stableGroups = ['QUALITY','LOGISTICS','OPERATION']
                const groups = (this.issueOptions || [])
                    .filter(item => stableGroups.indexOf(item.value) > -1
                        || this.findWorkTypeNode([item],this.workOrderInfo.issueCode))
                    .map(item => ({
                        ...item,
                        // 线下打款是独立一级类型，避免与历史“运营 / 线下退款”节点值重复，
                        // 否则 Cascader 会把一级选项回显成旧的二级路径。
                        children:(item.children || [])
                            .filter(child => child.value !== 'OFFLINE_REFUND')
                            .map(child => ({...child})),
                    }))
                groups.push({
                    value:'OFFLINE_REFUND',
                    label:'线下打款',
                    issueCode:'OFFLINE_REFUND',
                    issueGroupCode:'OFFLINE_PAYMENT',
                    issueGroupName:'线下打款',
                })
                return groups
            },
            selectedIssue(){
                return this.findWorkTypeNode(this.issueOptions,this.workOrderInfo.issueCode)
            },
            isQualityIssue(){
                return (this.selectedIssue && this.selectedIssue.issueGroupCode === 'QUALITY')
                    || (!this.selectedIssue && this.workOrderInfo.workOrderTypeGroup === '质量')
            },
            isOperationIssue(){
                return (this.selectedIssue && this.selectedIssue.issueGroupCode === 'OPERATION')
                    || (!this.selectedIssue && this.workOrderInfo.workOrderTypeGroup === '运营')
            },
            isOfflineRefundIssue(){
                return this.workOrderInfo.workOrderTypeGroup === '线下打款'
                    || this.workOrderInfo.issueCode === 'OFFLINE_REFUND'
            },
            showOfflinePaymentCreateForm(){
                return this.useStableClassification
                    && this.canFullEdit
                    && (this.isOfflineRefundIssue
                        || this.workflowForms.handleResult.handleMode === 'COMPENSATION')
            },
            createFlowPreviewText(){
                if(this.isOfflineRefundIssue){
                    return '提交后进入赔付专员处理；完成打款并上传凭证后直接关闭工单，无需责任划分'
                }
                const handleMode = this.workflowForms.handleResult.handleMode
                if(['REISSUE','REFUND','REISSUE_AND_REFUND'].indexOf(handleMode) > -1){
                    return '提交后直接关闭工单'
                }
                if(handleMode === 'COMPENSATION'){
                    return '提交后进入赔付专员处理，完成打款和初步责任划分后进入责任确认，确认通过后关闭工单'
                }
                if(handleMode === 'UPGRADE'){
                    return '提交后进入客诉专员处理；客诉专员可直接关闭，也可转入赔付流程'
                }
                return '选择处理结果后，这里会显示预计的工单流转路径'
            },
            isCompensationWorkflow(){
                return this.workflowForms.handleResult.handleMode === 'COMPENSATION'
            },
            isUpgradeWorkflow(){
                return this.workflowForms.handleResult.handleMode === 'UPGRADE'
            },
            isUpgradePaymentWorkflow(){
                return this.isUpgradeWorkflow
                    && this.workflowForms.complaint.paymentRequired === true
            },
            showPaymentWorkflowCard(){
                return this.isOfflineRefundIssue
                    || this.isCompensationWorkflow
                    || this.isUpgradePaymentWorkflow
                    || !!this.workflowDetail.payment
                    || !!this.workflowDetail.responsibility
                    || this.workflowEdit.payment
                    || this.workflowEdit.paymentComplete
                    || this.workflowEdit.responsibilityFinal
            },
            isPaymentSpecialistStage(){
                const actions = this.workflowDetail.availableActions || []
                return actions.indexOf('HANDLE_PAYMENT') > -1
            },
            paymentVoucherAttachments(){
                return this.workflowAttachments.filter(item => item.attachmentCategory === 'PAYMENT_VOUCHER')
            },
            canTransferComplaint(){
                const capabilities = (this.workflowDetail && this.workflowDetail.capabilities) || {}
                return this.workflowActiveModule === 'COMPLAINT' && capabilities.canHandleComplaint === true
            },
            transferableComplaintSpecialists(){
                const specialists = (this.workflowDetail && this.workflowDetail.complaintSpecialists) || []
                const currentUserId = ((this.workflowDetail && this.workflowDetail.currentAssignee) || {}).userId
                return specialists.filter(user => String(user.userId) !== String(currentUserId || ''))
            },
            complaintImageAttachments(){
                return this.workflowAttachments.filter(item => item.attachmentCategory === 'COMPLAINT_IMAGE')
            },
            processTimelineItems(){
                const matchedAttachmentIds = {}
                const auditItems = (this.workflowDetail.auditLogs || []).map(item => {
                    const attachments = item.actionCode === 'ATTACHMENT_ADD'
                        ? this.workflowAttachments.filter(attachment => String(attachment.id) === String(item.businessId))
                        : []
                    attachments.forEach(attachment => { matchedAttachmentIds[String(attachment.id)] = true })
                    return Object.assign({},item,{timelineKey:'audit-' + item.id,attachments:attachments})
                })
                const attachmentItems = this.workflowAttachments.filter(item => !matchedAttachmentIds[String(item.id)]).map(item => ({
                    id:'attachment-' + item.id,
                    timelineKey:'attachment-' + item.id,
                    moduleCode:item.moduleCode || 'WORKFLOW',
                    actionCode:'ATTACHMENT_ADD',
                    businessId:item.id,
                    operatorUserId:item.uploadUserId,
                    createTime:item.createTime,
                    attachments:[item]
                }))
                const timestamp = value => {
                    const parsed = new Date(String(value || '').replace(/-/g,'/')).getTime()
                    return isNaN(parsed) ? 0 : parsed
                }
                return auditItems.concat(attachmentItems).sort((left,right) => timestamp(right.createTime) - timestamp(left.createTime))
            },
            complaintSpecialistOptions(){
                return this.workflowDetail.complaintSpecialists || []
            },
            configuredPaymentSpecialistName(){
                const users = this.workflowDetail.paymentSpecialists || []
                return users.length ? (users[0].userName || users[0].userId) : '赔付专员（系统配置）'
            },
            canUploadPaymentVoucher(){
                const capabilities = this.workflowDetail.capabilities || {}
                return capabilities.canUploadPaymentVoucher === true || this.workflowEdit.paymentComplete === true
            },
            canPhysicalDelete(){
                const capabilities = this.workflowDetail.capabilities || {}
                return String(this.workOrderNo) !== '0' && capabilities.canPhysicalDelete === true
            },
            paymentRequiresFinalResponsibility(){
                if(this.isOfflineRefundIssue) return false
                if(this.workflowForms.payment.completionStatus !== 'COMPLETED') return false
                return String(this.workflowForms.responsibility.selectionKey || '').split(':')[0] === 'SUPPLIER'
            },
            paymentCompleteButtonText(){
                if(this.isOfflineRefundIssue && this.workflowForms.payment.completionStatus === 'COMPLETED') return '提交线下打款并关闭工单'
                if(this.workflowForms.payment.completionStatus === 'NOT_REQUIRED') return '提交赔付处理并关闭工单'
                if(this.workflowForms.payment.completionStatus === 'COMPLETED' && this.paymentRequiresFinalResponsibility) return '提交赔付处理并进入责任确认'
                if(this.workflowForms.payment.completionStatus === 'COMPLETED') return '提交赔付处理并关闭工单'
                return '提交赔付处理'
            },
            isSupportedTemperatureZone(){
                return ['COLD','AMBIENT'].indexOf(this.workOrderInfo.temperatureZone) > -1
            },
            responsibleOptions(){
                const code = this.workOrderInfo.factoryCode
                return (this.factoryOptions || []).filter(item => item.factoryCode === code)
            },
            factorySelectOptions(){
                const seen = {}
                return (this.factoryOptions || []).filter(item => {
                    if(seen[item.factoryCode]) return false
                    seen[item.factoryCode] = true
                    return true
                })
            },
            workOrderPictureUrls(){
                return (this.workOrderInfo.workOrderPics || []).map(item => item.picUrl).filter(Boolean)
            },
            aiImageUrls(){
                return this.aiImages.map(item => item.url).filter(Boolean)
            },
            missingPictureWarning(){
                if(!this.isQualityIssue) return ''
                const categories = (this.workOrderInfo.workOrderPics || []).map(item => item.picCategory)
                const missing = []
                if(this.workOrderInfo.temperatureZone === 'COLD'){
                    if(categories.indexOf('PRODUCT_STATUS') === -1) missing.push('产品状态图片')
                    if(categories.indexOf('BATCH') === -1) missing.push('批次图片')
                }else if(this.workOrderInfo.temperatureZone === 'AMBIENT'){
                    if(categories.indexOf('OUTER_PACKAGE') === -1) missing.push('外包装图片')
                    if(categories.indexOf('PRODUCT_STATUS') === -1) missing.push('产品状态图片')
                    if(categories.indexOf('BATCH') === -1) missing.push('批次图片')
                }
                if(missing.length === 0) return ''
                return `${this.temperatureZoneText(this.workOrderInfo.temperatureZone)}商品还缺少：${missing.join('、')}`
            },
            pictureRequirementText(){
                if(!this.isQualityIssue) return '非质量问题不要求质量判定图片，可按实际需要上传'
                if(this.workOrderInfo.temperatureZone === 'AMBIENT'){
                    return this.missingPictureWarning || '常温商品图片已齐全：外包装、产品状态、批次'
                }
                if(this.workOrderInfo.temperatureZone === 'COLD'){
                    return this.missingPictureWarning || '低温商品图片已齐全：产品状态、批次'
                }
                return '温层待确认：建议先上传产品状态和批次图片，确认温层后系统会提示缺失项'
            },
            hasOrderDetail(){
                return Object.keys(this.orderDetailInfo || {}).length > 0
            },
        },
        watch:{
            workOrderInfo:{
                deep:true,
                handler(){
                    this.scheduleDraftSave()
                },
            },
            offlineProduct:{
                deep:true,
                handler(){
                    this.scheduleDraftSave()
                },
            },
            'workOrderInfo.orderOnline':{
                handler(value){
                    if(Number(value) === 2) this.initOfflineProductOptions()
                },
            },
            offlinePayment:{
                deep:true,
                handler(){
                    this.scheduleDraftSave()
                },
            },
            'workflowForms.handleResult':{
                deep:true,
                handler(){
                    this.scheduleDraftSave()
                },
            },
        },
        mounted(){
            if(this.clientWidth<500){
                this.columnsCount = 1
            }else{
                this.columnsCount = 2
            }
            this.resizeHandler = ()=>{
                if(this.componentDestroyed) return
                this.clientWidth =document.body.clientWidth
                if(this.clientWidth<500){
                    this.columnsCount = 1
                }else{
                    this.columnsCount = 2
                }
            }
            window.addEventListener('resize',this.resizeHandler)
            if(this.$route.params.id!=0){
                this.loading = true
                this.initList().then(() => {
                    if(!this.componentDestroyed && !this.isDraftWorkOrder){
                        this.initWorkflowDetail()
                    }
                })
            }else{
                this.restoreDraft()
            }
            this.initWorkflowRoleOptions()
            this.initUserList()
            this.initDeptList()
            this.initIssueOptions()
            this.initLegacyTypeList()
            this.initOrderSourceList()

        },
        beforeDestroy(){
            this.componentDestroyed = true
            this.workOrderRequestSeq += 1
            this.issueRequestSeq += 1
            this.productLineRequestSeq += 1
            this.factoryRequestSeq += 1
            this.shopRouteRequestSeq += 1
            if(this.resizeHandler){
                window.removeEventListener('resize',this.resizeHandler)
            }
            if(this.draftSaveTimer){
                clearTimeout(this.draftSaveTimer)
            }
            if(this.orderInfoAttentionTimer){
                clearTimeout(this.orderInfoAttentionTimer)
            }
        },
        methods: {
            initOfflineProductOptions(){
                if(this.offlineProductLoading || this.offlineProductOptions.length > 0) return
                this.offlineProductLoading = true
                this.$apiGet('lechun-csms/bdProduct/getProducts').then(res => {
                    if(this.componentDestroyed) return
                    this.offlineProductOptions = Array.isArray(res) ? res : []
                    this.hydrateOfflineProductFromOptions()
                }).catch(() => {
                    if(!this.componentDestroyed) this.$message.error('系统商品加载失败，请稍后重试')
                }).finally(() => {
                    if(!this.componentDestroyed) this.offlineProductLoading = false
                })
            },
            handleOfflineProductDropdownVisible(visible){
                if(visible) this.initOfflineProductOptions()
            },
            offlineProductOptionLabel(item){
                const name = item && (item.cname || item.value) ? (item.cname || item.value) : '未命名商品'
                return item && item.cbarcode ? `${name}（${item.cbarcode}）` : name
            },
            hydrateOfflineProductFromOptions(){
                if(!this.offlineProduct.barCode) return
                const selected = (this.offlineProductOptions || []).find(item => String(item.cbarcode) === String(this.offlineProduct.barCode))
                if(!selected) return
                this.offlineProduct = {
                    cguid:selected.cguid || '',
                    productName:selected.cname || selected.value || '',
                    productCode:selected.ccode || '',
                    barCode:selected.cbarcode || '',
                    pici:this.offlineProduct.pici || '',
                }
            },
            handleOfflineProductChange(barCode){
                const selected = (this.offlineProductOptions || []).find(item => String(item.cbarcode) === String(barCode))
                if(!selected){
                    this.offlineProduct = {cguid:'',productName:'',productCode:'',barCode:'',pici:''}
                    return
                }
                const productChanged = String(this.offlineProduct.cguid || '') !== String(selected.cguid || '')
                this.offlineProduct = {
                    cguid:selected.cguid || '',
                    productName:selected.cname || selected.value || '',
                    productCode:selected.ccode || '',
                    barCode:selected.cbarcode || '',
                    pici:productChanged ? '' : (this.offlineProduct.pici || ''),
                }
            },
            handleDetailTabClick(tab){
                if(tab && tab.name === 'ORDER_INFO'){
                    this.clearOrderInfoTabAttention()
                }
                const moduleCodes = this.workflowModuleTabs.map(item => item.code)
                if(tab && moduleCodes.indexOf(tab.name) > -1){
                    this.workflowActiveModule = tab.name
                }
            },
            clearOrderInfoTabAttention(){
                this.orderInfoTabAttention = false
                if(this.orderInfoAttentionTimer){
                    clearTimeout(this.orderInfoAttentionTimer)
                    this.orderInfoAttentionTimer = null
                }
            },
            highlightOrderInfoTab(){
                this.clearOrderInfoTabAttention()
                if(this.detailActiveTab === 'ORDER_INFO' || !this.hasOrderDetail) return
                this.orderInfoTabAttention = true
                this.orderInfoAttentionTimer = setTimeout(() => {
                    if(this.componentDestroyed) return
                    this.orderInfoTabAttention = false
                    this.orderInfoAttentionTimer = null
                },2400)
            },
            isWorkflowModuleActive(code){
                return this.workflowActiveModule === code
            },
            initWorkflowRoleOptions(){
                return this.$apiGet('lechun-csms/workOrder/workflow/role-options',{}).then(res => {
                    if(this.componentDestroyed) return
                    const options = res || {}
                    this.$set(this.workflowDetail,'complaintSpecialists',options.complaintSpecialists || [])
                    this.$set(this.workflowDetail,'paymentSpecialists',options.paymentSpecialists || [])
                    this.$set(this.workflowDetail,'responsibilityConfirmers',options.responsibilityConfirmers || [])
                }).catch(() => {
                    if(!this.componentDestroyed) this.$message.warning('工作流角色配置加载失败，请刷新后重试')
                })
            },
            openComplaintTransfer(){
                this.complaintTransfer = {visible:true,targetUserId:'',remark:''}
            },
            submitComplaintTransfer(){
                if(!this.complaintTransfer.targetUserId){ this.$message.warning('请选择接收人'); return }
                const node = (this.workflowDetail.nodes || []).find(item => item.nodeType === 'COMPLAINT_HANDLE')
                this.workflowSaving.complaintTransfer = true
                this.$apiPost('lechun-csms/workOrder/workflow/complaint/transfer',{
                    workOrderNo:this.workOrderNo,
                    targetUserId:this.complaintTransfer.targetUserId,
                    remark:this.complaintTransfer.remark || '',
                    nodeVersion:node && node.version !== undefined ? node.version : 0
                }).then(() => {
                    if(this.componentDestroyed) return
                    this.$message.success('已转交，等待接收人继续处理')
                    this.complaintTransfer.visible = false
                    this.initWorkflowDetail()
                }).catch(err => {
                    if(!this.componentDestroyed) this.$message.error((err && err.message) || '转交失败，请刷新后重试')
                }).finally(() => { this.workflowSaving.complaintTransfer = false })
            },
            initWorkflowDetail(){
                if(String(this.workOrderNo) === '0') return
                this.workflowLoading = true
                this.$apiPost('lechun-csms/workOrder/workflow/initialize',{workOrderNo:this.workOrderNo})
                .then(() => this.$apiGet('lechun-csms/workOrder/workflow/detail',{workOrderNo:this.workOrderNo}))
                .then(res => {
                    if(this.componentDestroyed) return
                    this.workflowDetail = res || {handleResult:null,complaint:null,payment:null,responsibility:null,responsibilityItems:[],auditLogs:[],nodes:[],capabilities:{}}
                    const capabilities = this.workflowDetail.capabilities || {}
                    this.editAble = capabilities.canEditBasic === true
                    const nodes = this.workflowDetail.nodes || []
                    this.workflowEdit.handleResult = capabilities.canEditHandleResult === true || capabilities.canSubmitResult === true
                    this.workflowEdit.complaint = capabilities.canHandleComplaint === true || capabilities.COMPLAINT_UPDATE === true
                    this.workflowEdit.payment = (capabilities.canRegisterPayment === true && !this.workflowDetail.payment) || capabilities.PAYMENT_UPDATE === true
                    this.workflowEdit.paymentComplete = capabilities.canCompletePayment === true && !!(this.workflowDetail.payment && this.workflowDetail.payment.id && this.workflowDetail.payment.paymentStatus === 'PENDING')
                    this.workflowEdit.responsibilityFinal = capabilities.canConfirmResponsibility === true
                    const availableModuleCodes = this.workflowModuleTabs.map(item => item.code)
                    const defaultModule = this.workflowDetail.defaultActiveTab
                    this.workflowActiveModule = availableModuleCodes.indexOf(defaultModule) > -1 ? defaultModule : (availableModuleCodes[0] || 'PROCESS_LOG')
                    // 附件允许在完整流程中持续补录；后端仍以登录态和工单存在性校验为准，且不开放删除。
                    this.workflowCanAttach = this.workOrderNo !== 0 && this.workOrderNo !== '0' && (capabilities.canSupplementAttachment === true || !Object.keys(capabilities).length)
                    this.loadWorkflowAttachments()
                    const h = this.workflowDetail.handleResult || {}
                    const c = this.workflowDetail.complaint || {}
                    const p = this.workflowDetail.payment || {}
                    const r = this.workflowDetail.responsibility || {}
                    const nodeVersion = type => { const node=nodes.find(item => item.nodeType === type); return node && node.version !== undefined ? node.version : 0 }
                    this.workflowForms.handleResult = {resultId:h.id || null,handleMode:h.handleMode || '', upgradeHandlerUserId:h.upgradeHandlerUserId || '', communicationResult:h.communicationResult || '', returnTrackingNo:h.returnTrackingNo || '', version:nodeVersion('INITIAL_SUBMISSION') || nodeVersion('DEPT_HANDLE'),recordVersion:h.version || 0}
                    if(p.id && p.requestedAmount !== null && p.requestedAmount !== undefined){
                        this.$set(this.offlinePayment,'requestedAmount',p.requestedAmount)
                    }
                    this.workflowForms.complaint = {complaintId:c.id || null,finalHandleText:c.finalHandleText || '', paymentRequired:h.handleMode === 'COMPENSATION' || c.paymentRequired === true, requestedAmount:c.requestedAmount || null, payeeAccount:'', payeeName:'', version:nodeVersion('COMPLAINT_HANDLE'),recordVersion:c.version || 0}
                    this.workflowForms.payment = {paymentId:p.id || null, paymentStatus:p.paymentStatus || 'PENDING', completionStatus:['COMPLETED','NOT_REQUIRED'].indexOf(p.paymentStatus) > -1 ? p.paymentStatus : '', requestedAmount:p.requestedAmount || c.requestedAmount || null, actualAmount:p.actualAmount || null, payeeAccount:'', payeeName:'', version:nodeVersion('PAYMENT'),recordVersion:p.version || 0}
                    const responsibilityItems = (this.workflowDetail.responsibilityItems || []).map(item => ({ownerType:item.ownerType || '',optionCode:item.optionCode || '',optionName:item.optionName || '',customText:item.customText || '',sortNo:item.sortNo || 0}))
                    const responsibilitySelection = this.responsibilitySelectionFromItems(responsibilityItems)
                    this.workflowForms.responsibility = {responsibilityId:r.id || null, items:responsibilityItems, selectionKey:responsibilitySelection.selectionKey, companyCustomText:responsibilitySelection.companyCustomText, supplierCustomText:responsibilitySelection.supplierCustomText, confirmRemark:r.confirmRemark || '', finalNodeVersion:nodeVersion('FINAL_RESPONSIBILITY'), responsibilityVersion:r.version || 0}
                    if(responsibilitySelection.multiple && this.workflowEdit.responsibilityFinal){
                        this.$message.warning('当前责任记录包含多项，请重新选择且只能保留一项')
                    }
                }).catch(err => { if(!this.componentDestroyed) this.$message.error((err && err.message) || '工作流加载失败') }).finally(() => { if(!this.componentDestroyed) this.workflowLoading = false })
            },
            workflowNodeStatusText(status){
                const map={PENDING:'待处理',PROCESSING:'处理中',COMPLETED:'已完成',SKIPPED:'已跳过',CANCELLED:'已取消'}
                return map[status] || status || '未知'
            },
            workflowNodeTypeText(type){
                const map={INITIAL_SUBMISSION:'提交工单',DEPT_HANDLE:'历史处理节点',COMPLAINT_HANDLE:'客诉处理',PAYMENT:'打款处理',PRELIMINARY_RESPONSIBILITY:'初步责任',FINAL_RESPONSIBILITY:'最终责任'}
                return map[type] || type || '-'
            },
            workflowNodeTagType(status){
                const map={COMPLETED:'success',PROCESSING:'warning',CANCELLED:'info',SKIPPED:'info',PENDING:''}
                return map[status] || ''
            },
            workflowAuditTitle(item){
                const exactMap = {
                    'HANDLE_RESULT:CREATE':'提交处理方案','HANDLE_RESULT:UPDATE':'更新处理方案',
                    'COMPLAINT_HANDLE:CREATE':'提交升级处理结果','COMPLAINT_HANDLE:UPDATE':'更新升级处理结果',
                    'COMPLAINT_HANDLE:TRANSFER':'转交升级处理',
                    'PAYMENT:CREATE':'创建赔付申请','PAYMENT:UPDATE':'更新赔付信息','PAYMENT:COMPLETE':'完成赔付处理',
                    'RESPONSIBILITY:CREATE':'提交初步责任','RESPONSIBILITY:FINAL_CONFIRM':'确认最终责任',
                    'WORK_ORDER:CREATE_AND_SUBMIT':'创建并提交工单','WORK_ORDER:CREATE_DRAFT':'创建工单草稿',
                    'WORK_ORDER:SUBMIT_DRAFT':'提交工单草稿','WORK_ORDER:UPDATE_DRAFT':'更新工单信息',
                    'WORK_ORDER:NOTIFY_HANDLER':'通知处理人','WORK_ORDER:PRODUCTION_REPLY':'提交生产回复',
                    'WORKFLOW:CLOSE':'关闭工单','WORKFLOW:ATTACHMENT_ADD':'上传附件','WORKFLOW:ATTACHMENT_DELETE':'删除附件'
                }
                const actionMap = {
                    CREATE:'创建记录',UPDATE:'更新记录',COMPLETE:'完成处理',FINAL_CONFIRM:'确认责任',CLOSE:'关闭工单',
                    ATTACHMENT_ADD:'上传附件',ATTACHMENT_DELETE:'删除附件',SAVE:'保存记录',NOTIFY_HANDLER:'通知处理人',
                    CREATE_AND_SUBMIT:'创建并提交工单',CREATE_DRAFT:'创建工单草稿',SUBMIT_DRAFT:'提交工单草稿',UPDATE_DRAFT:'更新工单信息'
                }
                return exactMap[(item.moduleCode || '') + ':' + (item.actionCode || '')] || actionMap[item.actionCode] || '处理工单'
            },
            workflowAuditOperator(item){
                if(item.operatorUserName) return item.operatorUserName
                const userId = item.operatorUserId
                const users = [].concat(this.workflowDetail.complaintSpecialists || [],this.workflowDetail.paymentSpecialists || [],this.workflowDetail.responsibilityConfirmers || [])
                const matchedUser = users.find(user => String(user.userId) === String(userId))
                if(matchedUser) return matchedUser.userName || matchedUser.userId
                const matchedNode = (this.workflowDetail.nodes || []).find(node => String(node.assigneeUserId) === String(userId) || String(node.completeUserId) === String(userId))
                if(matchedNode) return matchedNode.completeUserName || matchedNode.assigneeUserName || '系统操作'
                return String(userId || '').indexOf('@') > -1 ? userId : '系统操作'
            },
            workflowAuditType(item){
                if(['CLOSE','COMPLETE','FINAL_CONFIRM'].indexOf(item.actionCode) > -1) return 'success'
                if(item.actionCode === 'ATTACHMENT_ADD') return 'primary'
                if(item.actionCode === 'ATTACHMENT_DELETE') return 'danger'
                if(item.actionCode === 'UPDATE') return 'warning'
                if(item.actionCode === 'TRANSFER') return 'warning'
                return ''
            },
            parseAuditObject(value){
                if(value === null || value === undefined || value === '') return {}
                if(typeof value === 'object') return value
                try {
                    const parsed = JSON.parse(value)
                    return parsed && typeof parsed === 'object' ? parsed : {description:parsed}
                } catch (e) {
                    return {description:value}
                }
            },
            auditChangeRows(item){
                if(item.actionCode === 'ATTACHMENT_ADD' && item.attachments && item.attachments.length) return []
                const before = this.parseAuditObject(item.beforeValue)
                const after = this.parseAuditObject(item.afterValue)
                const keys = Array.from(new Set(Object.keys(before).concat(Object.keys(after))))
                return keys.map(key => {
                    const label = this.auditFieldLabel(key)
                    const hasBefore = Object.prototype.hasOwnProperty.call(before,key) && before[key] !== null && before[key] !== ''
                    const hasAfter = Object.prototype.hasOwnProperty.call(after,key) && after[key] !== null && after[key] !== ''
                    return {
                        key:key,label:label,hasBefore:hasBefore,hasAfter:hasAfter,
                        before:this.formatAuditFieldValue(key,before[key]),
                        after:this.formatAuditFieldValue(key,after[key])
                    }
                }).filter(row => row.label && (row.hasBefore || row.hasAfter))
            },
            auditFieldLabel(key){
                const labels = {
                    description:'处理说明',submitted:'提交方式',handleMode:'处理方案',communicationResult:'沟通结果',returnTrackingNo:'退回物流单号',
                    finalHandleText:'最终处理',paymentRequired:'是否赔付',paymentStatus:'赔付状态',status:'处理状态',workOrderStatus:'工单状态',
                    requestedAmount:'申请金额',actualAmount:'实际金额',payeeAccountMask:'收款账号',responsibilityRequired:'是否需要责任确认',
                    attachmentCategory:'附件类型',fileSize:'文件大小',itemCount:'责任项数',confirmRemark:'确认说明',paymentScene:'赔付场景',
                    productionReply:'生产回复',communicationStatus:'沟通状态',upgradeHandlerUserName:'升级处理人',handlerUserName:'处理人',
                    assigneeUserName:'处理人',transferRemark:'转交说明'
                }
                return labels[key] || ''
            },
            formatAuditFieldValue(key,value){
                if(value === null || value === undefined || value === '') return '-'
                const maps = {
                    handleMode:{REISSUE:'补发',REFUND:'退款',REISSUE_AND_REFUND:'补发并退款',COMPENSATION:'赔付',UPGRADE:'升级处理'},
                    paymentStatus:{PENDING:'待处理',COMPLETED:'已打款',NOT_REQUIRED:'无需打款'},
                    status:{PENDING:'待处理',PROCESSING:'处理中',SUBMITTED:'已提交',CONFIRMED:'已确认',COMPLETED:'已完成',NOT_REQUIRED:'无需处理',CANCELLED:'已取消'},
                    workOrderStatus:{0:'已作废',1:'草稿',2:'处理中',3:'处理完成待确认',10:'已关闭',20:'升级处理中',30:'赔付处理中',40:'责任确认中'},
                    communicationStatus:{NO_REPLY_REQUIRED:'无需生产回复',WAITING_REPLY:'待生产回复',REPLIED:'已回复',RESULT_AVAILABLE:'已有处理结果'},
                    attachmentCategory:{COMPLAINT_IMAGE:'附件图片',PAYEE_ACCOUNT_IMAGE:'用户账号截图',PAYMENT_VOUCHER:'打款凭证',OTHER:'其他补充图片'},
                    paymentScene:{OFFLINE_REFUND:'线下退款',COMPENSATION:'赔付',UPGRADE_COMPENSATION:'升级转赔付'}
                }
                if(maps[key] && maps[key][value] !== undefined) return maps[key][value]
                if(key === 'submitted') return value === true || value === 'true' ? '已提交' : '保存草稿'
                if(key === 'paymentRequired' || key === 'responsibilityRequired') return value === true || value === 'true' ? '是' : '否'
                if(key === 'fileSize') return this.formatFileSize(value)
                if(key === 'requestedAmount' || key === 'actualAmount'){
                    const amount = Number(value)
                    return isNaN(amount) ? String(value) : '¥' + amount.toFixed(2)
                }
                if(key === 'finalHandleText' && value === 'saved') return '已填写'
                // 升级处理结论按业务要求完整展示，不做数字打码。
                if(key === 'finalHandleText') return String(value)
                if(typeof value === 'boolean') return value ? '是' : '否'
                if(typeof value === 'object') return '已更新'
                return String(value).replace(/\d{11,}/g,'***')
            },
            formatFileSize(value){
                const size = Number(value)
                if(isNaN(size) || size < 0) return '-'
                if(size < 1024) return size + ' B'
                if(size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB'
                return (size / 1024 / 1024).toFixed(1) + ' MB'
            },
            workflowToken(prefix){ return prefix + '-' + Date.now() + '-' + Math.random().toString(36).slice(2,8) },
            loadWorkflowAttachments(){
                // 附件允许提交后补录；赔付处理人可在当前节点删除本人误传的打款凭证。
                // 附加时间戳避免网关或浏览器复用旧的空列表响应。
                this.$apiGet('lechun-csms/workOrder/workflow/attachments',{workOrderNo:this.workOrderNo,moduleCode:'WORKFLOW',_:Date.now()}).then(list => {
                    const categoryNames={COMPLAINT_IMAGE:'附件图片',PAYEE_ACCOUNT_IMAGE:'用户账号截图',PAYMENT_VOUCHER:'打款凭证',OTHER:'其他补充图片'}
                    this.workflowAttachments = (list || []).map(item => ({
                        id:item.id,moduleCode:item.moduleCode,businessId:item.businessId,attachmentCategory:item.attachmentCategory,
                        fileName:item.fileName,fileSize:item.fileSize,uploadUserId:item.uploadUserId,createTime:item.createTime,
                        name:(categoryNames[item.attachmentCategory] || '图片') + ' · ' + (item.fileName || '图片'),url:item.fileUrl,status:'success'
                    }))
                }).catch(err => { this.$message.error((err && err.message) || '工作流附件加载失败') })
            },
            hasWorkflowAttachmentCategory(category){
                return this.workflowAttachments.some(item => item.attachmentCategory === category)
            },
            uploadPaymentVoucher(upload){
                this.uploadWorkflowAttachment(upload,'PAYMENT_VOUCHER')
            },
            pastePaymentVoucher(event){
                const clipboardData = event.clipboardData || window.clipboardData
                const items = clipboardData && clipboardData.items ? Array.from(clipboardData.items) : []
                const imageItem = items.find(item => item.kind === 'file' && /^image\//.test(item.type))
                if(!imageItem){ this.$message.warning('剪贴板中没有可上传的图片'); return }
                const source = imageItem.getAsFile()
                if(!source){ this.$message.warning('无法读取剪贴板图片'); return }
                const extension = (source.type.split('/')[1] || 'png').replace('jpeg','jpg')
                const file = new File([source],'打款凭证-' + Date.now() + '.' + extension,{type:source.type})
                event.preventDefault()
                this.uploadWorkflowAttachment({file:file},'PAYMENT_VOUCHER')
            },
            removePaymentVoucher(item){
                if(!item || !item.id) return
                this.$confirm('确认删除这张打款凭证？删除后可重新上传。','删除打款凭证',{type:'warning'}).then(() => {
                    const query = '?id=' + encodeURIComponent(item.id) + '&workOrderNo=' + encodeURIComponent(this.workOrderNo)
                    return this.$apiPost('lechun-csms/workOrder/workflow/attachment/delete' + query,{})
                }).then(() => {
                    this.$message.success('打款凭证已删除')
                    this.loadWorkflowAttachments()
                }).catch(err => {
                    if(err !== 'cancel' && err !== 'close') this.$message.error((err && err.message) || '打款凭证删除失败')
                })
            },
            uploadComplaintImage(upload){
                this.uploadWorkflowAttachment(upload,'COMPLAINT_IMAGE')
            },
            pasteComplaintImage(event){
                const clipboardData = event.clipboardData || window.clipboardData
                const items = clipboardData && clipboardData.items ? Array.from(clipboardData.items) : []
                const imageItem = items.find(item => item.kind === 'file' && /^image\//.test(item.type))
                if(!imageItem){ this.$message.warning('剪贴板中没有可上传的图片'); return }
                const source = imageItem.getAsFile()
                if(!source){ this.$message.warning('无法读取剪贴板图片'); return }
                const extension = (source.type.split('/')[1] || 'png').replace('jpeg','jpg')
                const file = new File([source],'附件图片-' + Date.now() + '.' + extension,{type:source.type})
                event.preventDefault()
                this.uploadWorkflowAttachment({file:file},'COMPLAINT_IMAGE')
            },
            removeComplaintImage(item){
                if(!item || !item.id) return
                this.$confirm('确认删除这张附件图片？删除后可重新上传。','删除附件图片',{type:'warning'}).then(() => {
                    const query = '?id=' + encodeURIComponent(item.id) + '&workOrderNo=' + encodeURIComponent(this.workOrderNo)
                    return this.$apiPost('lechun-csms/workOrder/workflow/attachment/delete' + query,{})
                }).then(() => {
                    this.$message.success('附件图片已删除')
                    this.loadWorkflowAttachments()
                }).catch(err => {
                    if(err !== 'cancel' && err !== 'close') this.$message.error((err && err.message) || '附件图片删除失败')
                })
            },
            uploadWorkflowAttachment(upload,categoryOverride){
                const file = upload && upload.file
                const category = categoryOverride || this.workflowAttachmentCategory
                if(category === 'PAYMENT_VOUCHER' && !this.canUploadPaymentVoucher){ this.$message.warning('只有打款处理人可以上传打款凭证'); return }
                if(!file || !/^image\//.test(file.type)){ this.$message.warning('仅支持图片附件'); return }
                const form = new FormData(); form.append('file',file)
                this.$apiUpload('lechun-cms/file/uploadFile',form).then(res => {
                    if(!res || Number(res.status) !== 200 || !res.value || !res.value[0]) throw new Error('图片上传失败')
                    return this.$apiPost('lechun-csms/workOrder/workflow/attachment',{workOrderNo:this.workOrderNo,moduleCode:'WORKFLOW',attachmentCategory:category,fileUrl:res.value[0],fileName:file.name,contentType:file.type,fileSize:file.size})
                }).then(() => { this.$message.success('附件上传成功'); this.loadWorkflowAttachments(); if(upload && upload.onSuccess) upload.onSuccess() }).catch(err => { this.$message.error((err && err.message) || '附件上传失败'); if(upload && upload.onError) upload.onError(err) })
            },
            workflowPost(url,payload,loadingKey,done){
                this.workflowSaving[loadingKey] = true
                this.$apiPost(url,payload).then(res => { if(done) done(res); this.$message.success('保存成功'); this.initWorkflowDetail(); this.initList() }).catch(err => { this.$message.error((err && err.message) || '保存失败') }).finally(() => { this.workflowSaving[loadingKey] = false })
            },
            submitWorkflowHandleResult(){
                const f=this.workflowForms.handleResult
                if(!f.handleMode){ this.$message.warning('请选择处理方式'); return }
                const update=!!f.resultId
                this.workflowPost(update?'lechun-csms/workOrder/workflow/handle-result/update':'lechun-csms/workOrder/workflow/handle-result',{workOrderNo:this.workOrderNo,resultId:f.resultId,handleMode:f.handleMode,upgradeHandlerUserId:f.upgradeHandlerUserId,communicationResult:f.communicationResult,returnTrackingNo:f.returnTrackingNo,requestToken:update?null:this.workflowToken('HANDLE'),version:f.version || 0,recordVersion:f.recordVersion || 0},'handleResult')
            },
            submitWorkflowComplaint(){
                const f=this.workflowForms.complaint
                const paymentRequired = this.isCompensationWorkflow ? true : f.paymentRequired
                if(!f.finalHandleText || paymentRequired === null){ this.$message.warning('请填写客诉处理信息'); return }
                if(paymentRequired && (!f.requestedAmount || f.requestedAmount <= 0)){ this.$message.warning('请填写有效申请金额'); return }
                if(paymentRequired && !f.complaintId && (!f.payeeName || !f.payeeAccount)){ this.$message.warning('请填写收款人和收款账号'); return }
                if(f.complaintId && (!!f.payeeName !== !!f.payeeAccount)){ this.$message.warning('修改收款信息时账号和姓名必须同时填写'); return }
                const update=!!f.complaintId
                this.workflowPost(update?'lechun-csms/workOrder/workflow/complaint/update':'lechun-csms/workOrder/workflow/complaint',{workOrderNo:this.workOrderNo,complaintId:f.complaintId,finalHandleText:f.finalHandleText,paymentRequired:paymentRequired,requestedAmount:paymentRequired?f.requestedAmount:null,payeeAccount:f.payeeAccount,payeeName:f.payeeName,requestToken:update?null:this.workflowToken('COMPLAINT'),version:f.version || 0,recordVersion:f.recordVersion || 0},'complaint')
            },
            submitWorkflowPayment(){
                const f=this.workflowForms.payment
                if(!f.requestedAmount || f.requestedAmount <= 0){ this.$message.warning('请填写有效申请金额'); return }
                if(this.isOfflineRefundIssue && !f.paymentId && (!f.payeeName || !f.payeeAccount)){ this.$message.warning('线下打款必须填写收款人和收款账号'); return }
                if(f.paymentId && (!!f.payeeName !== !!f.payeeAccount)){ this.$message.warning('修改收款信息时账号和姓名必须同时填写'); return }
                const update=!!f.paymentId
                this.workflowPost(update?'lechun-csms/workOrder/workflow/payment/update':'lechun-csms/workOrder/workflow/payment',{workOrderNo:this.workOrderNo,paymentId:f.paymentId,paymentStatus:f.paymentStatus,requestedAmount:f.requestedAmount,payeeAccount:f.payeeAccount,payeeName:f.payeeName,requestToken:update?null:this.workflowToken('PAYMENT'),version:f.version || 0,recordVersion:f.recordVersion || 0},'payment')
            },
            completeWorkflowPayment(){
                const f=this.workflowForms.payment
                if(!f.paymentId){ this.$message.warning('请先保存赔付申请'); return }
                if(['COMPLETED','NOT_REQUIRED'].indexOf(f.completionStatus) === -1){ this.$message.warning('请选择是否打款'); return }
                if(f.completionStatus === 'COMPLETED' && (!f.actualAmount || f.actualAmount <= 0)){ this.$message.warning('请填写实际打款金额'); return }
                if(f.completionStatus === 'COMPLETED' && !this.hasWorkflowAttachmentCategory('PAYMENT_VOUCHER')){ this.$message.warning('已打款时必须上传打款凭证'); return }
                const needsResponsibility = f.completionStatus === 'COMPLETED' && !this.isOfflineRefundIssue
                const responsibilityItems = needsResponsibility ? this.validateResponsibilitySelection() : []
                if(needsResponsibility && !responsibilityItems) return
                this.workflowForms.responsibility.items = responsibilityItems
                this.workflowPost('lechun-csms/workOrder/workflow/payment/complete',{
                    workOrderNo:this.workOrderNo,
                    paymentId:f.paymentId,
                    paymentStatus:f.completionStatus,
                    actualAmount:f.completionStatus === 'COMPLETED' ? f.actualAmount : null,
                    responsibilityItems:responsibilityItems,
                    requestToken:this.workflowToken('PAYMENT_COMPLETE'),
                    version:f.version || 0
                },'paymentComplete',() => {
                    const nextModule = f.completionStatus === 'COMPLETED' && this.paymentRequiresFinalResponsibility ? 'RESPONSIBILITY' : 'PROCESS_LOG'
                    this.detailActiveTab = nextModule
                    this.workflowActiveModule = nextModule
                })
            },
            responsibilityGroupForItem(item){
                const ownerType = String((item && item.ownerType) || '').trim()
                if(['COMPANY','公司','公司承担'].indexOf(ownerType) > -1) return this.responsibilityGroups[0]
                if(['SUPPLIER','供应商','供应商承担'].indexOf(ownerType) > -1) return this.responsibilityGroups[1]
                return null
            },
            responsibilityOptionValue(group,option){
                return group.ownerType + ':' + option.code
            },
            isResponsibilityOptionSelected(group,optionCode){
                return (this.workflowForms.responsibility || {}).selectionKey === group.ownerType + ':' + optionCode
            },
            responsibilitySelectionFromItems(items){
                const values={selectionKey:'',companyCustomText:'',supplierCustomText:'',multiple:false}
                const selections=[]
                ;(items || []).forEach(item => {
                    const group=this.responsibilityGroupForItem(item)
                    if(!group) return
                    const option=group.options.find(optionItem => optionItem.code === item.optionCode || optionItem.name === item.optionName)
                    const optionCode=option ? option.code : 'OTHER'
                    values[group.customKey]=optionCode === 'OTHER' ? (item.customText || item.optionName || '') : (item.customText || '')
                    selections.push(this.responsibilityOptionValue(group,{code:optionCode}))
                })
                values.multiple=selections.length > 1
                values.selectionKey=selections.length === 1 ? selections[0] : ''
                return values
            },
            buildResponsibilityItems(){
                const form=this.workflowForms.responsibility || {}
                const selectionKey=String(form.selectionKey || '')
                const group=this.responsibilityGroups.find(groupItem => selectionKey.indexOf(groupItem.ownerType + ':') === 0)
                if(!group) return []
                const optionCode=selectionKey.slice(group.ownerType.length + 1)
                const option=group.options.find(optionItem => optionItem.code === optionCode)
                if(!option) return []
                return [{ownerType:group.ownerType,optionCode:option.code,optionName:option.name,customText:option.code === 'OTHER' ? String(form[group.customKey] || '').trim() : '',sortNo:0}]
            },
            validateResponsibilitySelection(){
                const form=this.workflowForms.responsibility || {}
                const items=this.buildResponsibilityItems()
                if(!items.length){ this.$message.warning('至少选择一项责任'); return null }
                const missingOther=this.responsibilityGroups.find(group => this.isResponsibilityOptionSelected(group,'OTHER') && !String(form[group.customKey] || '').trim())
                if(missingOther){ this.$message.warning('请填写' + missingOther.label + '的其他责任内容'); return null }
                return items
            },
            submitWorkflowResponsibility(){
                const f=this.workflowForms.responsibility
                const responsibilityItems = this.validateResponsibilitySelection()
                if(!responsibilityItems) return
                const confirmRemark = String(f.confirmRemark || '').trim()
                if(!confirmRemark){ this.$message.warning('请填写确认说明'); return }
                f.confirmRemark = confirmRemark
                f.items = responsibilityItems
                this.workflowPost('lechun-csms/workOrder/workflow/responsibility',{workOrderNo:this.workOrderNo,responsibilityId:f.responsibilityId,stage:'FINAL',items:responsibilityItems,confirmRemark:confirmRemark,requestToken:this.workflowToken('RESP_FINAL'),version:f.finalNodeVersion || 0,responsibilityVersion:f.responsibilityVersion || 0},'responsibilityFinal')
            },
            formatAmount(value){
                if(value === null || value === undefined || value === ''){
                    return '-';
                }
                const amount = Number(value);
                return Number.isNaN(amount) ? value : amount.toFixed(2);
            },
            paymentStatusText(status){
                return {PENDING:'待处理',COMPLETED:'已打款',NOT_REQUIRED:'无需打款'}[status] || '暂无'
            },
            relateTypeText(value){
                const item = this.relateTypeList.find(option => option.key === Number(value))
                return item ? item.title : '无关联'
            },
            temperatureZoneText(value){
                return {COLD:'低温',AMBIENT:'常温',UNKNOWN:'待确认'}[value] || '待确认'
            },
            temperatureZoneTagType(value){
                return {COLD:'',AMBIENT:'success',UNKNOWN:'warning'}[value] || 'warning'
            },
            communicationStatusText(value){
                const item = this.communicationStatusOptions.find(option => option.value === value)
                return item ? item.label : '未设置'
            },
            communicationStatusTagType(value){
                return {
                    PENDING_REPLY:'warning',
                    REPLIED:'success',
                    RESULT_AVAILABLE:'',
                    NO_REPLY_REQUIRED:'info',
                }[value] || 'info'
            },
            pictureCategoryText(value){
                const item = this.pictureCategoryOptions.find(option => option.value === value)
                return item ? item.label : '其他'
            },
            aiFieldLabel(value){
                return {
                    someID:'外部单号',
                    issueCode:'售后问题',
                    temperatureZone:'商品温层',
                    productLineCode:'产品线',
                    factoryCode:'工厂',
                    shopCode:'店铺',
                    handleUserId:'通知处理人',
                    workOrderDesc:'售后问题描述',
                    communicationResult:'沟通结果',
                    productionQuestion:'待生产回复问题',
                    orderRelation:'订单关联信息',
                }[value] || value
            },
            userDisplayName(user){
                return user ? (user.USER_NAME || user.USER_NICK || user.USER_ID) : '-'
            },
            userNameById(userId){
                const user = this.userList.find(item => String(item.USER_ID) === String(userId))
                return user ? this.userDisplayName(user) : (userId || '-')
            },
            normalizeWorkOrderInfo(info){
                const source = info || {}
                const workOrderPics = source.workOrderPics && source.workOrderPics.length > 0
                    ? source.workOrderPics.map((item,index) => ({
                        ...item,
                        picCategory:item.picCategory || 'OTHER',
                        picIndex:item.picIndex || index + 1,
                    }))
                    : (source.picList || []).map((picUrl,index) => ({
                        picUrl,
                        picCategory:'OTHER',
                        picIndex:index + 1,
                    }))
                const products = (source.workOrderProductList || []).map(item => ({
                    ...item,
                    picList:item.picList || [],
                }))
                if(Number(source.orderOnline) === 2){
                    const offlineSource = products.find(item => Number(item.isChosen) === 1) || products[0] || {}
                    const offlineDraft = source.offlineProduct || {}
                    this.offlineProduct = {
                        cguid:offlineSource.cguid || source.cguid || offlineDraft.cguid || '',
                        productName:offlineSource.productName || source.productName || offlineDraft.productName || '',
                        productCode:offlineSource.productCode || source.productCode || offlineDraft.productCode || '',
                        barCode:offlineSource.barCode || source.barCode || offlineDraft.barCode || '',
                        pici:offlineSource.pici || source.pici || offlineDraft.pici || '',
                    }
                }
                const offlinePaymentDraft = source.offlinePayment || {}
                this.offlinePayment = {
                    requestedAmount:source.offlinePaymentAmount || offlinePaymentDraft.requestedAmount || null,
                    payeeName:source.offlinePayeeName || offlinePaymentDraft.payeeName || '',
                    payeeAccount:source.offlinePayeeAccount || offlinePaymentDraft.payeeAccount || '',
                }
                let communicationStatus = source.communicationStatus
                if(!communicationStatus){
                    if(source.productionReply) communicationStatus = 'REPLIED'
                    else if(source.productionQuestion) communicationStatus = 'PENDING_REPLY'
                    else if(source.communicationResult) communicationStatus = 'RESULT_AVAILABLE'
                    else communicationStatus = 'NO_REPLY_REQUIRED'
                }
                let workOrderTypeCode = source.workOrderTypeCode
                if(workOrderTypeCode !== null && workOrderTypeCode !== undefined && workOrderTypeCode !== ''){
                    workOrderTypeCode = Number(workOrderTypeCode)
                }
                let issueCode = source.issueCode || ''
                if(!issueCode && (source.workOrderTypeGroup === '线下打款'
                    || source.workOrderTypeName === '线下打款')){
                    issueCode = 'OFFLINE_REFUND'
                }
                return {
                    orderOnline:1,
                    productLineCode:'',
                    factoryCode:'',
                    shopCode:'',
                    qualityReturnTrackingNo:'',
                    communicationResult:'',
                    productionQuestion:'',
                    productionReply:'',
                    ...source,
                    issueCode,
                    workOrderTypeCode,
                    temperatureZone:source.temperatureZone || 'UNKNOWN',
                    temperatureZoneOriginal:source.temperatureZoneOriginal || '',
                    createUserName:source.createUserName || '',
                    handleUserName:source.handleUserName || '',
                    handleUserEmail:source.handleUserEmail || '',
                    responsibleDeptName:source.responsibleDeptName || '',
                    communicationStatus,
                    workOrderPics,
                    workOrderProductList:products,
                    workOrderFlowList:source.workOrderFlowList || [],
                }
            },
            mergeRelatedWorkOrderInfo(relatedInfo,preserveSnapshot){
                const source = relatedInfo || {}
                if(preserveSnapshot){
                    return this.normalizeWorkOrderInfo({
                        ...this.workOrderInfo,
                        someID:source.someID || this.workOrderInfo.someID,
                    })
                }
                const relatedSnapshot = {
                    someID:source.someID || this.workOrderInfo.someID,
                    relateType:source.relateType === null || source.relateType === undefined
                        ? 0 : source.relateType,
                    orderNo:source.orderNo || '',
                    refundNo:source.refundNo || '',
                    customerId:source.customerId || '',
                    orderOnline:source.orderOnline === null || source.orderOnline === undefined
                        ? 1 : source.orderOnline,
                    orderSource:source.orderSource || '',
                    onlineShopName:source.onlineShopName || '',
                    offlineShopName:source.offlineShopName || '',
                    offlineOrderNo:source.offlineOrderNo || '',
                    contactName:source.contactName || '',
                    contactPhone:source.contactPhone || '',
                    contactAddr:source.contactAddr || '',
                    temperatureZone:source.temperatureZone || 'UNKNOWN',
                    shopCode:source.shopCode || '',
                    workOrderProductList:source.workOrderProductList || [],
                }
                return this.normalizeWorkOrderInfo({
                    ...this.workOrderInfo,
                    ...relatedSnapshot,
                })
            },
            normalizeRouters(wayNos){
                return (wayNos || []).reduce((all,item) => {
                    if(Array.isArray(item)) return all.concat(item)
                    if(item && Array.isArray(item.data)) return all.concat(item.data)
                    if(item && Array.isArray(item.routers)) return all.concat(item.routers)
                    if(item && Array.isArray(item.traces)) return all.concat(item.traces)
                    if(item && (item.time || item.context)) all.push(item)
                    return all
                },[])
            },
            syncProductSelection(){
                const chosen = (this.workOrderInfo.workOrderProductList || []).filter(item => item.isChosen === 1)
                this.multipleSelProList = chosen
                if(Number(this.workOrderInfo.orderOnline) === 2 && chosen.length){
                    const product = chosen[0]
                    this.offlineProduct = {
                        cguid:product.cguid || '',
                        productName:product.productName || '',
                        productCode:product.productCode || '',
                        barCode:product.barCode || '',
                        pici:product.pici || '',
                    }
                }
                this.$nextTick(() => {
                    if(this.componentDestroyed) return
                    const table = this.$refs.salesProTable
                    if(!table) return
                    table.clearSelection()
                    chosen.forEach(item => table.toggleRowSelection(item,true))
                })
            },
            initList(from) {
                const requestSeq = ++this.workOrderRequestSeq
                const requestedSomeID = from === 'getOrder'
                    ? String(this.workOrderInfo.someID || '').trim() : ''
                const relationChanged = from === 'getOrder'
                    && Boolean(this.resolvedRelationSomeID)
                    && requestedSomeID !== this.resolvedRelationSomeID
                if(relationChanged){
                    this.clearOrderInfoTabAttention()
                    this.orderDetailInfo = {}
                    this.routers = []
                    this.clearQualityRouteSelection()
                    if(this.useStableClassification && this.isOperationIssue){
                        this.clearClassificationRoute()
                    }
                    this.workOrderInfo = this.normalizeWorkOrderInfo({
                        ...this.workOrderInfo,
                        relateType:0,
                        orderNo:'',
                        refundNo:'',
                        customerId:'',
                        orderSource:'',
                        onlineShopName:'',
                        offlineShopName:'',
                        offlineOrderNo:'',
                        contactName:'',
                        contactPhone:'',
                        contactAddr:'',
                        temperatureZone:'UNKNOWN',
                        shopCode:'',
                        workOrderProductList:[],
                    })
                    this.syncProductSelection()
                }
                let apiUrl
                let param
                if(from=='getOrder'){
                    apiUrl = 'lechun-csms/workOrder/getWorkOrderRelateInfo'
                    param = {
                        someID:requestedSomeID,
                        workOrderNo:this.workOrderInfo.workOrderNo || this.workOrderNo,
                    }
                }else{
                    apiUrl = 'lechun-csms/workOrder/workOrderDetail'
                    param = {workOrderNo:this.workOrderNo}
                }
                this.loading = true
                return this.$apiGet(apiUrl,param).then(res => {
                    if(this.componentDestroyed || requestSeq !== this.workOrderRequestSeq) return
                    this.loading = false
                    if(from === 'getOrder'
                        && requestedSomeID !== String(this.workOrderInfo.someID || '').trim()) return
                    const relatedInfo = res.workOrderInfo || {}
                    if(from === 'getOrder'){
                        const preserveSnapshot = this.shouldPreserveRelationSnapshot(relatedInfo)
                        if(!preserveSnapshot){
                            this.orderDetailInfo = res.orderDetail || {}
                            this.routers = this.normalizeRouters(res.wayNos)
                        }
                        this.workOrderInfo = this.mergeRelatedWorkOrderInfo(relatedInfo,preserveSnapshot)
                        this.resolvedRelationSomeID = requestedSomeID
                        this.$nextTick(() => {
                            if(this.componentDestroyed || requestSeq !== this.workOrderRequestSeq) return
                            this.highlightOrderInfoTab()
                        })
                    }else{
                        this.orderDetailInfo = res.orderDetail || {}
                        this.routers = this.normalizeRouters(res.wayNos)
                        this.classificationMode = relatedInfo.issueCode
                            || relatedInfo.workOrderTypeGroup === '线下打款'
                            || Number(relatedInfo.workOrderStatus) === 1 ? 'stable' : 'legacy'
                        this.workOrderInfo = this.normalizeWorkOrderInfo(relatedInfo)
                        this.originalStableSelection = this.captureStableSelection(this.workOrderInfo)
                        this.originalRelationSelection = this.captureRelationSelection(this.workOrderInfo)
                        this.resolvedRelationSomeID = String(this.workOrderInfo.someID || '').trim()
                    }
                    this.syncProductSelection()
                    this.ensureCurrentIssueOption()
                    this.syncClassificationOptions()
                }).catch(() => {
                    if(this.componentDestroyed || requestSeq !== this.workOrderRequestSeq) return
                    this.loading = false
                })
            },
            initUserList() {
                this.$apiGet('lechun-baseservice/user/getUserListForDorpbox',{}).then(res => {
                    if(this.componentDestroyed) return
                    this.userList = res || []

                })
            },
            initDeptList() {
                this.$apiGet('lechun-csms/workOrder/getWorkOrderResponseDept',{}).then(res => {
                    if(this.componentDestroyed) return
                    this.deptList = res

                })
            },
            initIssueOptions() {
                const requestSeq = ++this.issueRequestSeq
                return this.$apiGet('lechun-csms/workOrder/classification/issues',{}).then(res => {
                    if(this.componentDestroyed || requestSeq !== this.issueRequestSeq) return
                    this.issueOptions = res || []
                    this.ensureCurrentIssueOption()
                    this.syncClassificationOptions()
                })
            },
            initLegacyTypeList() {
                this.$apiGet('lechun-csms/workOrder/workOrderTypeList',{}).then(res => {
                    if(this.componentDestroyed) return
                    this.legacyTypeOptions = res || []
                })
            },
            initOrderSourceList() {
                this.$apiGet('lechun-csms/workOrder/getWorkOrderSourceList',{}).then(res => {
                    if(this.componentDestroyed) return
                    this.orderSourceList = res
                })
            },
            getOrder() {
                const someID = (this.workOrderInfo.someID || '').trim()
                if(!someID){
                    this.$message.warning('请先输入外部单号')
                    return
                }
                this.$set(this.workOrderInfo,'someID',someID)
                this.initList('getOrder')
            },
            toBuyer(id) {
                this.$router.push({name: 'userDetail', params: {id: id}})
            },
            findWorkTypeNode(nodes,value){
                for(let i = 0; i < (nodes || []).length; i++){
                    const item = nodes[i]
                    if(String(item.value) === String(value)) return item
                    const child = this.findWorkTypeNode(item.children,value)
                    if(child) return child
                }
                return null
            },
            captureStableSelection(info){
                if(!info || !info.issueCode) return null
                return {
                    issueCode:info.issueCode,
                    temperatureZone:info.temperatureZone,
                    productLineCode:info.productLineCode,
                    factoryCode:info.factoryCode,
                    shopCode:info.shopCode,
                }
            },
            captureRelationSelection(info){
                if(!info) return null
                return {
                    someID:String(info.someID || '').trim(),
                    relateType:Number(info.relateType || 0),
                }
            },
            shouldPreserveRelationSnapshot(relatedInfo){
                if(this.isNewWorkOrder() || !this.originalRelationSelection
                    || !this.originalRelationSelection.someID){
                    return false
                }
                const source = relatedInfo || {}
                const requestedSomeID = String(source.someID || this.workOrderInfo.someID || '').trim()
                return Number(source.relateType || 0) === 0
                    && requestedSomeID === this.originalRelationSelection.someID
            },
            isOriginalStableSelection(fields){
                const original = this.originalStableSelection
                if(!original) return false
                return Object.keys(fields).every(key =>
                    String(original[key] || '') === String(fields[key] || ''))
            },
            shouldPreserveCurrentAssignee(fields){
                return Boolean(this.workOrderInfo.handleUserId)
                    && this.isOriginalStableSelection(fields)
            },
            ensureCurrentIssueOption(){
                const issueCode = this.workOrderInfo.issueCode
                if(!issueCode || this.findWorkTypeNode(this.issueOptions,issueCode)) return
                const groupName = this.workOrderInfo.workOrderTypeGroup || '历史售后问题'
                const groupCode = {物流:'LOGISTICS',质量:'QUALITY',运营:'OPERATION'}[groupName] || 'HISTORY'
                const options = (this.issueOptions || []).map(item => ({
                    ...item,
                    children:[...(item.children || [])],
                }))
                let group = options.find(item => item.value === groupCode)
                if(!group){
                    group = {value:groupCode,label:groupName,children:[]}
                    options.push(group)
                }
                group.children.push({
                    value:issueCode,
                    label:`${this.workOrderInfo.workOrderTypeName || issueCode}（已停用）`,
                    issueCode,
                    issueGroupCode:groupCode,
                    issueGroupName:groupName,
                    responsibleUserId:this.workOrderInfo.handleUserId,
                    responsibleDeptDingdingId:this.workOrderInfo.responsibleDeptDingdingId,
                    disabled:true,
                })
                this.issueOptions = options
            },
            handleWorkOrderGroupChange(groupName){
                this.$set(this.workOrderInfo,'workOrderTypeGroup',groupName || '')
                this.$set(this.workOrderInfo,'issueCode','')
                this.$set(this.workOrderInfo,'workOrderTypeCode',null)
                this.$set(this.workOrderInfo,'workOrderTypeName',groupName === '线下打款' ? '线下打款' : '')
                this.$set(this.workOrderInfo,'productLineCode','')
                this.$set(this.workOrderInfo,'factoryCode','')
                this.$set(this.workOrderInfo,'shopCode','')
                this.productLineOptions = []
                this.factoryOptions = []
                this.clearClassificationRoute()
                if(groupName === '线下打款'){
                    this.$set(this.workOrderInfo,'handleUserId','')
                    this.$set(this.workOrderInfo,'handleUserName','')
                    this.$set(this.workflowForms.handleResult,'handleMode','COMPENSATION')
                    this.$set(this.workflowForms.handleResult,'upgradeHandlerUserId','')
                }else if(this.workflowForms.handleResult.handleMode === 'COMPENSATION'){
                    this.$set(this.workflowForms.handleResult,'handleMode','')
                }
            },
            handleStableTypeChange(issueCode){
                const wasOfflineRefund = this.isOfflineRefundIssue
                if(issueCode === 'OFFLINE_REFUND'){
                    this.handleWorkOrderGroupChange('线下打款')
                    this.$set(this.workOrderInfo,'issueCode','OFFLINE_REFUND')
                    return Promise.resolve()
                }
                if(wasOfflineRefund && this.workflowForms.handleResult.handleMode === 'COMPENSATION'){
                    this.$set(this.workflowForms.handleResult,'handleMode','')
                    this.$set(this.workflowForms.handleResult,'upgradeHandlerUserId','')
                }
                this.$set(this.workOrderInfo,'issueCode',issueCode || '')
                return this.handleIssueChange(issueCode)
            },
            handleIssueChange(issueCode,targetProductLineCode,targetFactoryCode){
                this.productLineRequestSeq += 1
                this.factoryRequestSeq += 1
                this.shopRouteRequestSeq += 1
                const issue = this.findWorkTypeNode(this.issueOptions,issueCode)
                this.$set(this.workOrderInfo,'workOrderTypeCode',null)
                this.$set(this.workOrderInfo,'workOrderTypeGroup',issue ? issue.issueGroupName : '')
                this.$set(this.workOrderInfo,'workOrderTypeName',issue ? issue.label : '')
                this.$set(this.workOrderInfo,'productLineCode','')
                this.$set(this.workOrderInfo,'factoryCode','')
                this.$set(this.workOrderInfo,'workOrderTypeMatClass','')
                this.$set(this.workOrderInfo,'workOrderTypeFactory','')
                if(!issue || issue.issueGroupCode !== 'QUALITY'){
                    this.$set(this.workOrderInfo,'qualityReturnTrackingNo','')
                }
                this.productLineOptions = []
                this.factoryOptions = []
                this.clearClassificationRoute()
                if(!issue){
                    return Promise.resolve()
                }
                if(issue.issueGroupCode === 'QUALITY'){
                    return this.loadProductLines(false,targetProductLineCode,targetFactoryCode)
                }else if(issue.issueGroupCode === 'OPERATION'){
                    return this.loadShopRoute()
                }else{
                    this.applyRouteUser(issue)
                    return Promise.resolve()
                }
            },
            handleTemperatureZoneChange(){
                if(!this.useStableClassification || !this.isQualityIssue) return Promise.resolve()
                this.productLineRequestSeq += 1
                this.$set(this.workOrderInfo,'productLineCode','')
                this.$set(this.workOrderInfo,'workOrderTypeMatClass','')
                this.productLineOptions = []
                return this.loadProductLines(false)
            },
            clearQualityRouteSelection(){
                this.productLineRequestSeq += 1
                this.factoryRequestSeq += 1
                this.$set(this.workOrderInfo,'productLineCode','')
                this.$set(this.workOrderInfo,'factoryCode','')
                this.$set(this.workOrderInfo,'workOrderTypeMatClass','')
                this.$set(this.workOrderInfo,'workOrderTypeFactory','')
                this.productLineOptions = []
                this.factoryOptions = []
                if(this.isQualityIssue){
                    this.clearClassificationRoute()
                }
            },
            handleProductLineChange(){
                const selected = this.productLineOptions.find(item => item.productLineCode === this.workOrderInfo.productLineCode)
                if(selected) this.$set(this.workOrderInfo,'workOrderTypeMatClass',selected.productLineName || '')
                return Promise.resolve()
            },
            handleFactoryChange(factoryCode){
                const routes = this.factoryOptions.filter(item => item.factoryCode === factoryCode)
                const route = routes[0]
                if(route){
                    this.$set(this.workOrderInfo,'workOrderTypeFactory',route.factoryName || '')
                    if(routes.length === 1) this.applyRouteUser(route)
                    else this.clearClassificationRoute()
                }else{
                    this.clearClassificationRoute()
                }
            },
            syncClassificationOptions(){
                if(!this.useStableClassification) return
                const issue = this.selectedIssue
                if(this.isQualityIssue){
                    this.loadProductLines(true)
                }else if(this.isOperationIssue){
                    this.loadShopRoute()
                }else if(issue && !this.shouldPreserveCurrentAssignee({
                    issueCode:this.workOrderInfo.issueCode,
                })){
                    this.applyRouteUser(issue)
                }
            },
            loadProductLines(preserveSelection,targetProductLineCode,targetFactoryCode){
                const requestSeq = ++this.productLineRequestSeq
                this.factoryRequestSeq += 1
                if(!this.isQualityIssue || !this.isSupportedTemperatureZone){
                    this.productLineOptions = []
                    this.factoryOptions = []
                    this.$set(this.workOrderInfo,'productLineCode','')
                    this.$set(this.workOrderInfo,'factoryCode','')
                    this.$set(this.workOrderInfo,'workOrderTypeMatClass','')
                    this.$set(this.workOrderInfo,'workOrderTypeFactory','')
                    this.clearClassificationRoute()
                    return Promise.resolve()
                }
                const temperatureZone = this.workOrderInfo.temperatureZone
                return this.$apiGet('lechun-csms/workOrder/classification/productLines',{temperatureZone}).then(res => {
                    if(this.componentDestroyed || requestSeq !== this.productLineRequestSeq
                        || temperatureZone !== this.workOrderInfo.temperatureZone || !this.isQualityIssue) return
                    this.productLineOptions = res || []
                    const desiredProductLineCode = targetProductLineCode || this.workOrderInfo.productLineCode
                    let selectedExists = this.productLineOptions.some(item =>
                        item.productLineCode === desiredProductLineCode)
                    if(!selectedExists && preserveSelection && desiredProductLineCode
                        && this.isOriginalStableSelection({
                            issueCode:this.workOrderInfo.issueCode,
                            temperatureZone,
                            productLineCode:desiredProductLineCode,
                        })){
                        this.productLineOptions.push({
                            productLineCode:desiredProductLineCode,
                            productLineName:`${this.workOrderInfo.workOrderTypeMatClass || desiredProductLineCode}（已停用）`,
                            disabled:true,
                        })
                        selectedExists = true
                    }
                    if(!selectedExists){
                        this.$set(this.workOrderInfo,'productLineCode','')
                        return this.loadFactories(Boolean(preserveSelection),targetFactoryCode)
                    }
                    this.$set(this.workOrderInfo,'productLineCode',desiredProductLineCode)
                    const selectedProductLine = this.productLineOptions.find(item =>
                        item.productLineCode === desiredProductLineCode)
                    if(selectedProductLine){
                        this.$set(this.workOrderInfo,'workOrderTypeMatClass',selectedProductLine.productLineName || '')
                    }
                    return this.loadFactories(Boolean(preserveSelection),targetFactoryCode)
                })
            },
            loadFactories(preserveSelection,targetFactoryCode){
                const requestSeq = ++this.factoryRequestSeq
                const temperatureZone = this.workOrderInfo.temperatureZone
                if(!this.isQualityIssue){
                    this.factoryOptions = []
                    return Promise.resolve()
                }
                return this.$apiGet('lechun-csms/workOrder/classification/factoryRoutes',{}).then(res => {
                    if(this.componentDestroyed || requestSeq !== this.factoryRequestSeq
                        || temperatureZone !== this.workOrderInfo.temperatureZone
                        || !this.isQualityIssue) return
                    this.factoryOptions = res || []
                    const desiredFactoryCode = targetFactoryCode || this.workOrderInfo.factoryCode
                    let selectedExists = this.factoryOptions.some(item =>
                        item.factoryCode === desiredFactoryCode)
                    if(!selectedExists && preserveSelection && desiredFactoryCode
                        && this.isOriginalStableSelection({
                            issueCode:this.workOrderInfo.issueCode,
                            temperatureZone,
                            factoryCode:desiredFactoryCode,
                        })){
                        this.factoryOptions.push({
                            temperatureZone,
                            productLineName:this.workOrderInfo.workOrderTypeMatClass || '',
                            factoryCode:desiredFactoryCode,
                            factoryName:`${this.workOrderInfo.workOrderTypeFactory || desiredFactoryCode}（已停用）`,
                            responsibleUserId:this.workOrderInfo.handleUserId,
                            responsibleDeptDingdingId:this.workOrderInfo.responsibleDeptDingdingId,
                            disabled:true,
                        })
                        selectedExists = true
                    }
                    if(selectedExists && (preserveSelection || targetFactoryCode)){
                        this.$set(this.workOrderInfo,'factoryCode',desiredFactoryCode)
                        const route = this.factoryOptions.find(item =>
                            item.factoryCode === desiredFactoryCode)
                        const preserveAssignee = this.shouldPreserveCurrentAssignee({
                            issueCode:this.workOrderInfo.issueCode,
                            temperatureZone,
                            factoryCode:desiredFactoryCode,
                        })
                        if(preserveAssignee){
                            if(route && !this.workOrderInfo.workOrderTypeMatClass){
                                this.$set(this.workOrderInfo,'workOrderTypeMatClass',route.productLineName || '')
                            }
                            if(route && !this.workOrderInfo.workOrderTypeFactory){
                                this.$set(this.workOrderInfo,'workOrderTypeFactory',route.factoryName || '')
                            }
                        }else{
                            this.handleFactoryChange(desiredFactoryCode)
                        }
                    }else if(this.factorySelectOptions.length === 1){
                        this.$set(this.workOrderInfo,'factoryCode',this.factorySelectOptions[0].factoryCode)
                        this.handleFactoryChange(this.factorySelectOptions[0].factoryCode)
                    }else{
                        this.$set(this.workOrderInfo,'factoryCode','')
                        this.clearClassificationRoute()
                    }
                })
            },
            loadShopRoute(){
                const requestSeq = ++this.shopRouteRequestSeq
                const shopCode = this.workOrderInfo.shopCode
                if(!this.isOperationIssue || !shopCode){
                    this.clearClassificationRoute()
                    return Promise.resolve()
                }
                const preserveAssignee = this.shouldPreserveCurrentAssignee({
                    issueCode:this.workOrderInfo.issueCode,
                    shopCode,
                })
                if(!preserveAssignee){
                    this.clearClassificationRoute()
                }
                return this.$apiGet('lechun-csms/workOrder/classification/shopRoute',{shopCode}).then(res => {
                    if(this.componentDestroyed || requestSeq !== this.shopRouteRequestSeq
                        || shopCode !== this.workOrderInfo.shopCode || !this.isOperationIssue) return
                    if(res && !preserveAssignee){
                        this.applyRouteUser(res)
                    }else if(this.isOriginalStableSelection({
                        issueCode:this.workOrderInfo.issueCode,
                        shopCode,
                    })){
                        // 已有工单允许保留后来停用的原店铺路由；新建或改店铺仍必须命中启用路由。
                        return
                    }else{
                        this.clearClassificationRoute()
                    }
                }).catch(() => {
                    if(this.componentDestroyed || requestSeq !== this.shopRouteRequestSeq
                        || shopCode !== this.workOrderInfo.shopCode || !this.isOperationIssue) return
                    if(!preserveAssignee){
                        this.clearClassificationRoute()
                    }
                })
            },
            applyRouteUser(route){
                const handleUserId = route.responsibleUserId || ''
                const deptId = route.responsibleDeptDingdingId || ''
                this.$set(this.workOrderInfo,'handleUserId',handleUserId)
                this.$set(this.workOrderInfo,'handleUserName',handleUserId ? this.userNameById(handleUserId) : '')
                this.$set(this.workOrderInfo,'responsibleDeptDingdingId',deptId)
                const dept = (this.deptList || []).find(item => String(item.key) === String(deptId))
                this.$set(this.workOrderInfo,'responsibleDeptName',dept ? dept.name : '')
            },
            clearClassificationRoute(){
                this.$set(this.workOrderInfo,'handleUserId','')
                this.$set(this.workOrderInfo,'handleUserName','')
                this.$set(this.workOrderInfo,'responsibleDeptDingdingId','')
                this.$set(this.workOrderInfo,'responsibleDeptName','')
            },
            handleWorkTypeChange(val,type){
                if(type=='workType'){
                    const data = this.findWorkTypeNode(this.legacyTypeOptions,val)
                    this.$set(this.workOrderInfo,'handleUserId',data && data.respUserId ? data.respUserId : '')
                    this.$set(this.workOrderInfo,'handleUserName',this.userNameById(this.workOrderInfo.handleUserId))
                    this.$set(this.workOrderInfo,'workOrderTypeName',data ? data.label : '')
                }else{
                    this.$set(this.workOrderInfo,type,val)
                }
            },
            validateWorkOrder(){
                if(!this.canFullEdit){
                    if(!(this.workOrderInfo.workOrderDesc || '').trim()) return '请填写售后问题描述'
                    if(this.workOrderInfo.communicationStatus === 'PENDING_REPLY' && !(this.workOrderInfo.productionQuestion || '').trim()) return '选择“待生产回复”时，请填写待生产回复问题'
                    if(this.workOrderInfo.communicationStatus === 'RESULT_AVAILABLE' && !(this.workOrderInfo.communicationResult || '').trim()) return '选择“已有沟通结果”时，请填写沟通结果'
                    if(this.workOrderInfo.communicationStatus === 'REPLIED' && !this.workOrderInfo.productionReply) return '尚无生产回复，不能选择“生产已回复”'
                    return ''
                }
                if(!this.workOrderInfo.orderOnline) return '请选择购买渠道'
                if(this.useStableClassification){
                    if(!this.workOrderInfo.workOrderTypeGroup) return '请选择工单类型'
                    if(!this.isOfflineRefundIssue && !this.workOrderInfo.issueCode) return '请选择售后问题'
                    if(this.isQualityIssue){
                        if(!this.isSupportedTemperatureZone) return '请确认商品温层'
                        if(!this.workOrderInfo.productLineCode) return '请选择产品线'
                        if(!this.workOrderInfo.factoryCode) return '请选择工厂'
                    }
                    if(this.isOperationIssue && !this.isOfflineRefundIssue && !this.workOrderInfo.shopCode){
                        return '当前订单缺少店铺编码，请先获取订单明细'
                    }
                    if(!this.isOfflineRefundIssue && !this.workOrderInfo.handleUserId) return '当前条件未配置通知处理人，请先完善路由配置'
                }else{
                    if(!this.workOrderInfo.workOrderTypeCode) return '请选择历史售后类型'
                    if(!this.workOrderInfo.handleUserId) return '该类型未配置通知处理人，请人工选择'
                }
                if(Number(this.workOrderInfo.orderOnline) === 2){
                    if(!(this.offlineProduct.cguid || '').trim()) return '线下工单必须从系统商品中选择商品名称'
                    if(!(this.offlineProduct.productName || '').trim()) return '所选商品缺少商品名称，请重新选择'
                    if(!(this.offlineProduct.barCode || '').trim()) return '所选商品缺少69码，请重新选择'
                    if(!(this.offlineProduct.productCode || '').trim()) return '线下工单必须填写物品编码'
                    if(!(this.offlineProduct.pici || '').trim()) return '线下工单必须填写批次'
                }
                if(this.showOfflinePaymentCreateForm){
                    if(!this.offlinePayment.requestedAmount || Number(this.offlinePayment.requestedAmount) <= 0) return '赔付必须填写申请金额'
                    if(!(this.offlinePayment.payeeName || '').trim()) return '赔付必须填写收款人'
                    if(!(this.offlinePayment.payeeAccount || '').trim()) return '赔付必须填写收款账号'
                }
                if(!this.isOfflineRefundIssue){
                    const result = this.workflowForms.handleResult
                    if(!result.handleMode) return '请选择处理结果'
                    if(result.handleMode === 'UPGRADE' && !result.upgradeHandlerUserId) return '请选择客诉专员'
                }
                if(!(this.workOrderInfo.workOrderDesc || '').trim()) return '请填写售后问题描述'
                if(this.workOrderInfo.communicationStatus === 'PENDING_REPLY'
                    && !(this.workOrderInfo.productionQuestion || '').trim()){
                    return '选择“待生产回复”时，请填写待生产回复问题'
                }
                if(this.workOrderInfo.communicationStatus === 'RESULT_AVAILABLE'
                    && !(this.workOrderInfo.communicationResult || '').trim()){
                    return '选择“已有沟通结果”时，请填写沟通结果'
                }
                if(this.workOrderInfo.communicationStatus === 'REPLIED'
                    && !this.workOrderInfo.productionReply){
                    return '尚无生产回复，不能选择“生产已回复”'
                }
                if(this.uploadingCount > 0) return '图片仍在上传，请稍后再提交'
                if(!(this.workOrderInfo.workOrderPics || []).length) return '请至少上传一张客诉图片'
                return ''
            },
            submitWorkOrder(){
                if(this.saving) return
                if(!this.canFullEdit){
                    const error = this.validateWorkOrder()
                    if(error){ this.$message.warning(error); return }
                    this.saveWorkOrder(false,'UPDATE')
                    return
                }
                const error = this.validateWorkOrder()
                if(error){
                    this.$message.warning(error)
                    return
                }
                if(this.missingPictureWarning){
                    this.$confirm(
                        `${this.missingPictureWarning}。若当前确实无法提供，可以确认后继续提交。`,
                        '图片信息不完整',
                        {confirmButtonText:'确认提交',cancelButtonText:'继续补图',type:'warning'}
                    ).then(() => {
                        if(!this.componentDestroyed) this.saveWorkOrder(true,'SUBMIT')
                    }).catch(() => {})
                    return
                }
                this.saveWorkOrder(false,'SUBMIT')
            },
            addWorkOrderSubmit(){
                this.submitWorkOrder()
            },
            handleAiPaste(event){
                const clipboardData = event.clipboardData || window.clipboardData
                if(!clipboardData || !clipboardData.items) return
                const files = []
                for(let i = 0; i < clipboardData.items.length; i++){
                    const item = clipboardData.items[i]
                    if(item.kind === 'file' && item.type && item.type.indexOf('image/') === 0){
                        const file = item.getAsFile()
                        if(file) files.push(file)
                    }
                }
                if(!files.length) return
                const pastedText = clipboardData.getData ? clipboardData.getData('text/plain') : ''
                if(!pastedText) event.preventDefault()
                files.forEach(file => this.uploadAiImage({file}))
            },
            uploadAiImage(upload){
                const file = upload && upload.file
                if(!file || !file.type || file.type.indexOf('image/') !== 0){
                    this.$message.warning('只能上传图片文件')
                    return Promise.resolve()
                }
                if(this.aiImages.length + this.aiUploadingCount >= 10){
                    this.$message.warning('AI识别最多上传10张图片')
                    return Promise.resolve()
                }
                const fileForm = new FormData()
                fileForm.append('file',file)
                this.aiUploadingCount += 1
                return this.$apiUpload('lechun-cms/file/uploadFile',fileForm).then(res => {
                    if(this.componentDestroyed) return
                    if(!res || Number(res.status) !== 200){
                        this.$message.error((res && res.message) || '图片上传失败，请稍后重试')
                        return
                    }
                    const url = res.value && res.value[0]
                    if(!url){
                        this.$message.error('图片上传成功，但未返回图片地址')
                        return
                    }
                    if(this.aiImages.some(item => item.url === url)) return
                    this.aiImages.push({url,name:file.name || '粘贴图片'})
                    this.aiResultVisible = false
                }).catch(() => {
                    // 网络异常由统一请求层提示。
                }).finally(() => {
                    this.aiUploadingCount = Math.max(0,this.aiUploadingCount - 1)
                })
            },
            removeAiImage(index){
                this.aiImages.splice(index,1)
                this.aiResultVisible = false
            },
            recognizeAiDraft(){
                const text = (this.aiInputText || '').trim()
                if(!text && !this.aiImages.length){
                    this.$message.warning('请填写文字或上传图片后再识别')
                    return
                }
                if(this.aiUploadingCount > 0){
                    this.$message.warning('图片仍在上传，请稍后再识别')
                    return
                }
                if(this.aiRecognizing) return
                this.aiRecognizing = true
                this.aiWarnings = []
                this.aiUnresolvedFields = []
                this.aiResultVisible = false
                this.$apiPost('lechun-csms/workOrder/aiParseDraft',{
                    text,
                    images:this.aiImages.map(item => ({url:item.url})),
                    currentDraft:this.buildSafeDraft(),
                }).then(result => this.applyAiDraft(result || {})).catch(() => {
                    // 接口异常由统一请求层提示，保留当前人工草稿。
                }).finally(() => {
                    if(!this.componentDestroyed) this.aiRecognizing = false
                })
            },
            hasOwnField(object,key){
                return Object.prototype.hasOwnProperty.call(object || {},key)
            },
            async applyAiDraft(result){
                if(this.componentDestroyed) return
                const draft = result.draft || {}
                const relatedData = result.relatedData || {}
                this.aiWarnings = [...(result.warnings || [])]
                this.aiUnresolvedFields = [...(result.unresolvedFields || [])]

                const authoritativeOrder = Number(draft.relateType || 0) > 0
                const orderFields = [
                    'someID','relateType','orderNo','refundNo','customerId','orderOnline','orderSource',
                    'onlineShopName','offlineShopName','offlineOrderNo','contactName','contactPhone',
                    'contactAddr','temperatureZone','shopCode','workOrderProductList',
                ]
                if(authoritativeOrder){
                    orderFields.forEach(key => {
                        if(!this.hasOwnField(draft,key)) return
                        const value = key === 'workOrderProductList'
                            ? (draft[key] || []).map(item => ({...item,picList:item.picList || []}))
                            : draft[key]
                        this.$set(this.workOrderInfo,key,value)
                    })
                    this.orderDetailInfo = relatedData.orderDetail || {}
                    this.routers = this.normalizeRouters(relatedData.wayNos)
                    this.resolvedRelationSomeID = String(draft.someID || '').trim()
                    this.syncProductSelection()
                }else if(!this.workOrderInfo.someID && draft.someID){
                    this.$set(this.workOrderInfo,'someID',draft.someID)
                }

                const hasManualCommunication = Boolean(
                    (this.workOrderInfo.communicationResult || '').trim()
                    || (this.workOrderInfo.productionQuestion || '').trim()
                    || this.workOrderInfo.communicationStatus !== 'NO_REPLY_REQUIRED'
                )
                ;['workOrderDesc','communicationResult','productionQuestion'].forEach(key => {
                    if(!(this.workOrderInfo[key] || '').trim() && (draft[key] || '').trim()){
                        this.$set(this.workOrderInfo,key,draft[key])
                    }
                })
                if(!hasManualCommunication && draft.communicationStatus){
                    this.$set(this.workOrderInfo,'communicationStatus',draft.communicationStatus)
                }
                if(!authoritativeOrder && this.workOrderInfo.temperatureZone === 'UNKNOWN'
                    && ['COLD','AMBIENT'].indexOf(draft.temperatureZone) > -1){
                    this.$set(this.workOrderInfo,'temperatureZone',draft.temperatureZone)
                }

                await this.initIssueOptions()
                if(this.componentDestroyed) return
                const currentIssueCode = this.workOrderInfo.issueCode
                const targetIssueCode = draft.issueCode || ''
                if(!currentIssueCode && targetIssueCode){
                    this.$set(this.workOrderInfo,'issueCode',targetIssueCode)
                    await this.handleIssueChange(
                        targetIssueCode,
                        draft.productLineCode || '',
                        draft.factoryCode || ''
                    )
                }else if(currentIssueCode && targetIssueCode
                    && String(currentIssueCode) === String(targetIssueCode)){
                    if(this.isQualityIssue){
                        await this.loadProductLines(
                            Boolean(this.workOrderInfo.productLineCode),
                            this.workOrderInfo.productLineCode || draft.productLineCode || '',
                            this.workOrderInfo.factoryCode || draft.factoryCode || ''
                        )
                    }else if(this.isOperationIssue){
                        await this.loadShopRoute()
                    }else if(this.selectedIssue){
                        this.applyRouteUser(this.selectedIssue)
                    }
                }else if(currentIssueCode && targetIssueCode
                    && String(currentIssueCode) !== String(targetIssueCode)){
                    this.aiWarnings.push('当前已选择售后问题，AI识别结果未覆盖，请人工核对')
                }

                const acceptedCategories = this.pictureCategoryOptions.map(item => item.value)
                const pictures = [...(this.workOrderInfo.workOrderPics || [])]
                const pictureUrls = new Set(pictures.map(item => item.picUrl))
                ;(draft.workOrderPics || []).forEach(item => {
                    if(!item || !item.picUrl || pictureUrls.has(item.picUrl)) return
                    pictures.push({
                        ...item,
                        picCategory:acceptedCategories.indexOf(item.picCategory) > -1
                            ? item.picCategory : 'OTHER',
                    })
                    pictureUrls.add(item.picUrl)
                })
                pictures.forEach((item,index) => { item.picIndex = index + 1 })
                this.$set(this.workOrderInfo,'workOrderPics',pictures)

                this.aiWarnings = [...new Set(this.aiWarnings.filter(Boolean))]
                this.aiUnresolvedFields = [...new Set(this.aiUnresolvedFields.filter(Boolean))]
                this.aiResultVisible = true
                this.$message.success('AI识别结果已回填，请核对后再保存')
            },
            createRequestToken(prefix){
                return `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`
            },
            isNewWorkOrder(){
                return String(this.workOrderNo) === '0'
            },
            buildSafeDraft(){
                const source = this.workOrderInfo || {}
                return {
                    someID:source.someID || '',
                    relateType:source.relateType,
                    orderOnline:source.orderOnline,
                    orderSource:source.orderSource || '',
                    onlineShopName:source.onlineShopName || '',
                    offlineShopName:source.offlineShopName || '',
                    offlineOrderNo:source.offlineOrderNo || '',
                    issueCode:source.issueCode || '',
                    productLineCode:source.productLineCode || '',
                    factoryCode:source.factoryCode || '',
                    shopCode:source.shopCode || '',
                    workOrderTypeCode:source.workOrderTypeCode || null,
                    workOrderTypeGroup:source.workOrderTypeGroup || '',
                    workOrderTypeName:source.workOrderTypeName || '',
                    workOrderTypeMatClass:source.workOrderTypeMatClass || '',
                    workOrderTypeFactory:source.workOrderTypeFactory || '',
                    handleUserId:source.handleUserId || '',
                    responsibleDeptDingdingId:source.responsibleDeptDingdingId || '',
                    temperatureZone:source.temperatureZone || 'UNKNOWN',
                    workOrderDesc:source.workOrderDesc || '',
                    communicationStatus:source.communicationStatus || 'NO_REPLY_REQUIRED',
                    communicationResult:source.communicationResult || '',
                    productionQuestion:source.productionQuestion || '',
                    offlineProduct:{...this.offlineProduct},
                    offlinePayment:{...this.offlinePayment},
                    initialHandleResult:{...this.workflowForms.handleResult},
                }
            },
            hasDraftContent(draft){
                return Boolean(
                    draft.someID || draft.orderSource || draft.offlineShopName || draft.offlineOrderNo
                    || draft.issueCode || draft.productLineCode || draft.factoryCode || draft.shopCode
                    || draft.workOrderTypeCode || draft.handleUserId || draft.responsibleDeptDingdingId
                    || draft.workOrderDesc || draft.communicationResult || draft.productionQuestion
                    || (draft.offlineProduct && (draft.offlineProduct.productName || draft.offlineProduct.barCode || draft.offlineProduct.productCode || draft.offlineProduct.pici))
                    || (draft.offlinePayment && (draft.offlinePayment.requestedAmount || draft.offlinePayment.payeeName || draft.offlinePayment.payeeAccount))
                    || (draft.initialHandleResult && (draft.initialHandleResult.handleMode || draft.initialHandleResult.communicationResult))
                    || draft.temperatureZone !== 'UNKNOWN'
                    || draft.communicationStatus !== 'NO_REPLY_REQUIRED'
                )
            },
            scheduleDraftSave(){
                if(this.componentDestroyed || !this.isNewWorkOrder() || !this.draftReady) return
                if(this.draftSaveTimer){
                    clearTimeout(this.draftSaveTimer)
                }
                this.draftSaveTimer = setTimeout(() => this.persistDraft(),500)
            },
            persistDraft(){
                this.draftSaveTimer = null
                if(this.componentDestroyed) return
                const draft = this.buildSafeDraft()
                try{
                    if(!this.hasDraftContent(draft)){
                        sessionStorage.removeItem(this.draftStorageKey)
                        return
                    }
                    sessionStorage.setItem(this.draftStorageKey,JSON.stringify({
                        expiresAt:Date.now() + this.draftTtlMs,
                        resolvedRelationSomeID:this.resolvedRelationSomeID,
                        data:draft,
                    }))
                }catch(e){
                    // 草稿是辅助能力，存储不可用时不阻断工单填写
                }
            },
            restoreDraft(){
                try{
                    const raw = sessionStorage.getItem(this.draftStorageKey)
                    if(!raw){
                        this.draftReady = true
                        return
                    }
                    const stored = JSON.parse(raw)
                    if(!stored || !stored.data || !stored.expiresAt || stored.expiresAt <= Date.now()){
                        sessionStorage.removeItem(this.draftStorageKey)
                        this.draftReady = true
                        return
                    }
                    this.workOrderInfo = this.normalizeWorkOrderInfo({
                        ...this.workOrderInfo,
                        ...stored.data,
                    })
                    this.offlineProduct = {...this.offlineProduct,...(stored.data.offlineProduct || {})}
                    this.offlinePayment = {...this.offlinePayment,...(stored.data.offlinePayment || {})}
                    this.workflowForms.handleResult = {
                        ...this.workflowForms.handleResult,
                        ...(stored.data.initialHandleResult || {}),
                    }
                    this.resolvedRelationSomeID = String(stored.resolvedRelationSomeID || '').trim()
                    this.$message.info('已恢复当前会话中未提交的工单草稿')
                }catch(e){
                    sessionStorage.removeItem(this.draftStorageKey)
                }finally{
                    this.draftReady = true
                }
            },
            clearDraft(){
                if(this.draftSaveTimer){
                    clearTimeout(this.draftSaveTimer)
                    this.draftSaveTimer = null
                }
                try{
                    sessionStorage.removeItem(this.draftStorageKey)
                }catch(e){
                    // sessionStorage 不可用时无需影响主流程
                }
            },
            buildWorkOrderProductListForSave(selectedProducts){
                if(Number(this.workOrderInfo.orderOnline) === 2){
                    const existing = (this.workOrderInfo.workOrderProductList || [])[0] || {}
                    return [{
                        ...existing,
                        cguid:(this.offlineProduct.cguid || '').trim(),
                        productName:(this.offlineProduct.productName || '').trim(),
                        productCode:(this.offlineProduct.productCode || '').trim(),
                        barCode:(this.offlineProduct.barCode || '').trim(),
                        pici:(this.offlineProduct.pici || '').trim(),
                        isChosen:1,
                        picList:existing.picList || [],
                    }]
                }
                return (this.workOrderInfo.workOrderProductList || []).map(item => ({
                    ...item,
                    isChosen:selectedProducts.indexOf(item) > -1 ? 1 : 0,
                }))
            },
            saveWorkOrder(confirmIncompletePictures,saveMode){
                if(this.saving) return
                if(!this.canFullEdit){
                    const param = {
                        workOrderNo:this.workOrderInfo.workOrderNo,
                        contactName:this.workOrderInfo.contactName,
                        contactPhone:this.workOrderInfo.contactPhone,
                        contactAddr:this.workOrderInfo.contactAddr,
                        orderSource:this.workOrderInfo.orderSource,
                        offlineShopName:this.workOrderInfo.offlineShopName,
                        offlineOrderNo:this.workOrderInfo.offlineOrderNo,
                        workOrderDesc:this.workOrderInfo.workOrderDesc,
                        communicationStatus:this.workOrderInfo.communicationStatus,
                        communicationResult:this.workOrderInfo.communicationResult,
                        productionQuestion:this.workOrderInfo.productionQuestion,
                        qualityReturnTrackingNo:this.isQualityIssue
                            ? (this.workOrderInfo.qualityReturnTrackingNo || '').trim() : null
                    }
                    this.saving = true
                    this.$apiPost('lechun-csms/workOrder/simpleUpdateWorkOrder',param).then(() => {
                        if(this.componentDestroyed) return
                        this.saving = false
                        this.$message({message:'工单信息已更新',type:'success',onClose:()=>this.$router.history.go(-1)})
                    }).catch(() => { if(!this.componentDestroyed) this.saving = false })
                    return
                }
                if(!this.saveRequestToken){
                    this.saveRequestToken = this.createRequestToken('work-order-save')
                }
                const selectedProducts = this.multipleSelProList
                const workOrderProductList = this.buildWorkOrderProductListForSave(selectedProducts)
                const param = {
                    ...this.workOrderInfo,
                    saveMode:saveMode || 'DRAFT',
                    workOrderTypeCode:this.useStableClassification
                        ? null : (this.workOrderInfo.workOrderTypeCode || null),
                    issueCode:this.useStableClassification ? this.workOrderInfo.issueCode : null,
                    productLineCode:this.useStableClassification ? this.workOrderInfo.productLineCode : null,
                    factoryCode:this.useStableClassification ? this.workOrderInfo.factoryCode : null,
                    shopCode:this.useStableClassification ? this.workOrderInfo.shopCode : null,
                    qualityReturnTrackingNo:this.isQualityIssue
                        ? (this.workOrderInfo.qualityReturnTrackingNo || '').trim() : null,
                    requestToken:this.saveRequestToken,
                    confirmIncompletePictures,
                    workOrderPics:(this.workOrderInfo.workOrderPics || []).map((item,index) => ({
                        picUrl:item.picUrl,
                        picCategory:item.picCategory,
                        picIndex:index + 1,
                    })),
                    workOrderProductList,
                    offlinePaymentAmount:this.showOfflinePaymentCreateForm ? this.offlinePayment.requestedAmount : null,
                    offlinePayeeName:this.showOfflinePaymentCreateForm ? (this.offlinePayment.payeeName || '').trim() : null,
                    offlinePayeeAccount:this.showOfflinePaymentCreateForm ? (this.offlinePayment.payeeAccount || '').trim() : null,
                    initialHandleResult:saveMode === 'SUBMIT' && !this.isOfflineRefundIssue ? {
                        handleMode:this.workflowForms.handleResult.handleMode,
                        upgradeHandlerUserId:this.workflowForms.handleResult.handleMode === 'UPGRADE'
                            ? this.workflowForms.handleResult.upgradeHandlerUserId : null,
                        communicationResult:(this.workflowForms.handleResult.communicationResult || '').trim(),
                        returnTrackingNo:this.workflowForms.handleResult.returnTrackingNo || null,
                    } : null,
                }
                this.saving = true
                this.$apiPost('lechun-csms/workOrder/saveWorkOrder',param).then(() => {
                    if(this.componentDestroyed) return
                    this.saving = false
                    this.saveRequestToken = ''
                    this.clearDraft()
                    this.$message({
                        message:saveMode === 'DRAFT' ? '草稿保存成功' : '工单提交成功',
                        type: 'success',
                        onClose: () => {
                            this.$router.history.go(-1)
                            // this.$router.push({name: 'workOrderList'})
                        }
                    })
                }).catch(() => {
                    if(this.componentDestroyed) return
                    this.saving = false
                })
            },
            physicalDeleteWorkOrder(){
                const workOrderNo = String(this.workOrderInfo.workOrderNo || this.workOrderNo || '').trim()
                if(!workOrderNo) return
                this.$prompt('物理删除不可恢复，请输入完整工单号 ' + workOrderNo + ' 确认','物理删除工单',{
                    confirmButtonText:'确认物理删除',
                    cancelButtonText:'取消',
                    type:'warning',
                    distinguishCancelAndClose:true,
                    inputValidator:value => String(value || '').trim() === workOrderNo || '请输入完整工单号',
                }).then(({value}) => {
                    this.physicalDeleting = true
                    return this.$apiPost('lechun-csms/workOrder/workflow/physical-delete',{
                        workOrderNo:workOrderNo,
                        confirmationWorkOrderNo:String(value || '').trim(),
                    })
                }).then(() => {
                    this.$message.success('工单已物理删除')
                    this.returnPage()
                }).catch(err => {
                    if(err !== 'cancel' && err !== 'close') this.$message.error((err && err.message) || '工单物理删除失败')
                }).finally(() => {
                    this.physicalDeleting = false
                })
            },
            returnPage() {
                window.history.go(-1)
                // this.$router.push({
                //     name: 'workOrderList'
                // })
            },
            uploadFile(file,type) {
                const pictureCategory = this.newPictureCategory
                const fileForm = new FormData()
                fileForm.append('file',file.file)
                this.uploadingCount += 1
                this.$apiUpload('lechun-cms/file/uploadFile',fileForm).then(res => {
                    if(this.componentDestroyed) return
                    if(!res || Number(res.status) !== 200){
                        this.$message.error((res && res.message) || '图片上传失败，请稍后重试')
                        return
                    }
                    const picUrl = res && res.value && res.value[0]
                    if(!picUrl){
                        this.$message.error('图片上传成功，但未返回图片地址')
                        return
                    }
                    if(type=='order'){
                        const pictures = this.workOrderInfo.workOrderPics || []
                        pictures.push({
                            picUrl,
                            picCategory:pictureCategory,
                            picIndex:pictures.length + 1,
                        })
                        this.$set(this.workOrderInfo,'workOrderPics',pictures)
                    }else{
                        const picList = type.picList || []
                        picList.push(picUrl)
                        this.$set(type,'picList',picList)
                    }
                }).catch(() => {
                    // 网络异常由统一请求层提示。
                }).finally(() => {
                    this.uploadingCount = Math.max(0,this.uploadingCount - 1)
                })
            },
            removeWorkOrderPic(index){
                const pictures = [...(this.workOrderInfo.workOrderPics || [])]
                pictures.splice(index,1)
                pictures.forEach((item,itemIndex) => { item.picIndex = itemIndex + 1 })
                this.$set(this.workOrderInfo,'workOrderPics',pictures)
            },
            removeProductPic(product,index){
                const pictures = [...(product.picList || [])]
                pictures.splice(index,1)
                this.$set(product,'picList',pictures)
            },
            submitProductionReply(){
                const reply = (this.productionReplyInput || '').trim()
                if(!reply){
                    this.$message.warning('请填写生产回复')
                    return
                }
                if(this.productionReplySaving) return
                if(!this.replyRequestToken){
                    this.replyRequestToken = this.createRequestToken('production-reply')
                }
                this.productionReplySaving = true
                this.$apiPost('lechun-csms/workOrder/productionReply',{
                    workOrderNo:this.workOrderInfo.workOrderNo || this.workOrderNo,
                    productionReply:reply,
                    requestToken:this.replyRequestToken,
                }).then(() => {
                    if(this.componentDestroyed) return
                    this.productionReplySaving = false
                    this.replyRequestToken = ''
                    this.productionReplyInput = ''
                    this.$message.success('生产回复已提交，并将通知工单发起人')
                    this.initList()
                }).catch(() => {
                    if(this.componentDestroyed) return
                    this.productionReplySaving = false
                })
            },
            handleSelectionChange(val){
                this.multipleSelProList = val
            },
            pasteImgFun(event,proItem){
                const clipboardData = event.clipboardData || window.clipboardData;

                if (clipboardData) {
                    let hasImage = false
                    for (let i = 0; i < clipboardData.items.length; i++) {
                        const item = clipboardData.items[i];
                        if (item.kind === 'file' && item.type.startsWith('image/')) {
                            const file = item.getAsFile();
                            hasImage = true
                            this.uploadFile({file:file},proItem?proItem:'order')
                        }
                    }
                    if(hasImage) event.preventDefault()
                    else this.$message.warning('剪贴板中没有可上传的图片')
                }
            }
        }
    }
</script>


<style lang="scss">
.work-order-page-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
}
.work-order-page-title{
    flex: 0 0 auto;
    margin: 0;
}
.work-order-page-title--clickable{
    cursor: pointer;
}
.work-order-header-meta{
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    min-width: 0;
    color: #606266;
}
.work-order-header-meta-item{
    display: flex;
    align-items: center;
    min-width: 0;
    padding: 0 18px;
    border-left: 1px solid #dcdfe6;
    font-size: 13px;
    white-space: nowrap;
}
.work-order-header-meta-item:last-child{
    border-right: 1px solid #dcdfe6;
}
.work-order-header-meta-label{
    margin-right: 8px;
    color: #909399;
}
.work-order-header-meta-value{
    overflow: hidden;
    color: #303133;
    font-weight: 500;
    text-overflow: ellipsis;
}
.work-order-header-actions{
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
}
.work-order-header-actions .work-order-header-action{
    min-width: 88px;
    height: 32px;
    margin-left: 0;
    padding: 0 14px;
}
.work-order-header-actions .work-order-header-action--delete{
    min-width: 118px;
}
.order-info-tab-label{
    display: inline-flex;
    align-items: center;
    gap: 8px;
}
.order-info-tab-status{
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 1px 6px;
    border: 1px solid rgba(32, 158, 145, .35);
    border-radius: 10px;
    color: #147d73;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
}
.order-info-tab-label--attention .order-info-tab-status{
    animation: order-info-tab-attention .8s ease-out 3;
}
@keyframes order-info-tab-attention{
    0%{
        opacity: .72;
        transform: scale(.94);
        box-shadow: 0 0 0 0 rgba(32, 158, 145, .32);
    }
    55%{
        opacity: 1;
        transform: scale(1.04);
        box-shadow: 0 0 0 5px rgba(32, 158, 145, .08);
    }
    100%{
        opacity: 1;
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(32, 158, 145, 0);
    }
}
@media (prefers-reduced-motion: reduce){
    .order-info-tab-label--attention .order-info-tab-status{
        animation: none;
    }
}
@media (max-width: 1200px){
    .work-order-page-header{
        flex-wrap: wrap;
    }
    .work-order-header-meta{
        order: 3;
        flex-basis: 100%;
        justify-content: flex-start;
    }
    .work-order-header-meta-item:first-child{
        padding-left: 0;
        border-left: 0;
    }
}
.work-order-detail-info {

    .workflow-panel{padding: 4px 0;}
    .workflow-card{margin-top: 12px;}
    .workflow-card .el-card__header{padding: 10px 14px;font-weight: 600;}
    .workflow-form{padding: 12px 0;border-bottom: 1px solid #ebeef5;margin-bottom: 12px;}
    .workflow-inline-alert{margin-bottom: 10px;}
    .workflow-primary-action{display:flex;justify-content:center;padding:16px 0 4px;}
    .workflow-primary-submit{min-width:280px;min-height:44px;padding:12px 28px;font-size:14px;}
    .work-order-submit-actions{display:flex;justify-content:center;padding:24px 0 8px;}
    .work-order-submit-button{min-width:280px;min-height:44px;padding:12px 28px;font-size:14px;}
    .workflow-log-card .el-card__body{padding:20px 24px 8px;}
    .workflow-timeline{padding-left:4px;}
    .workflow-timeline .el-timeline-item{padding-bottom:24px;}
    .workflow-timeline .el-timeline-item__timestamp{color:#909399;font-size:12px;}
    .audit-entry{padding:2px 0 0;}
    .audit-entry__header{display:flex;align-items:center;gap:12px;min-height:24px;}
    .audit-entry__title{color:#303133;font-size:15px;font-weight:600;}
    .audit-entry__operator{padding-left:12px;border-left:1px solid #dcdfe6;color:#606266;font-size:13px;}
    .audit-change-list{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px 20px;margin-top:12px;padding:12px 16px;border-radius:4px;background:#f7f8fa;}
    .audit-change-row{display:flex;min-width:0;color:#606266;font-size:13px;line-height:22px;}
    .audit-change-row__label{flex:0 0 92px;color:#909399;}
    .audit-change-row__value{min-width:0;word-break:break-word;}
    .audit-change-row__before{color:#909399;text-decoration:line-through;}
    .audit-change-row__arrow{margin:0 7px;color:#c0c4cc;}
    .audit-attachment-section{margin-top:12px;}
    .audit-attachment-section__title{color:#606266;font-size:13px;font-weight:500;}
    .audit-attachment-list{margin-top:8px;}
    .workflow-attachment-hint{margin-top:8px;color:#909399;font-size:12px;}
    .workflow-attachment-list{display:flex;flex-wrap:wrap;gap:10px;margin-top:10px;}
    .workflow-attachment-item{width:112px;color:#606266;font-size:12px;line-height:18px;}
    .workflow-attachment-item--removable{position:relative;}
    .workflow-attachment-item .el-image{display:block;width:112px;height:90px;border:1px solid #ebeef5;border-radius:4px;}
    .workflow-attachment-item span{display:block;margin-top:4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    .workflow-attachment-remove{position:absolute;top:-8px;right:-8px;padding:6px;box-shadow:0 2px 6px rgba(0,0,0,.18);}
    .workflow-payment-paste{display:inline-flex;align-items:center;min-height:30px;margin-left:10px;padding:0 12px;border:1px dashed #20a394;border-radius:4px;color:#168f82;cursor:text;vertical-align:top;outline:none;}
    .workflow-payment-paste:focus{border-style:solid;box-shadow:0 0 0 2px rgba(32,163,148,.16);}
    .responsibility-form-item .el-form-item__content{line-height:normal;}
    .responsibility-single-choice-hint{margin-bottom:10px;color:#606266;font-size:13px;}
    .responsibility-global-group{display:block;width:100%;}
    .responsibility-allocation{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:20px;width:100%;}
    .responsibility-card{min-height:230px;padding:20px 24px;border:1px solid #dcdfe6;border-radius:4px;background:#fff;box-sizing:border-box;}
    .responsibility-card__title{margin-bottom:16px;color:#1677ff;font-size:16px;font-weight:600;}
    .responsibility-options{display:flex;flex-direction:column;align-items:flex-start;gap:10px;}
    .responsibility-options .el-radio{margin-right:0;}
    .responsibility-other-input{margin-top:14px;}

    @media (max-width: 768px){
        .workflow-log-card .el-card__body{padding:16px 14px 4px;}
        .audit-entry__header{align-items:flex-start;flex-direction:column;gap:4px;}
        .audit-entry__operator{padding-left:0;border-left:0;}
        .audit-change-list{grid-template-columns:1fr;padding:10px 12px;}
        .audit-change-row__label{flex-basis:80px;}
        .responsibility-allocation{grid-template-columns:1fr;}
        .workflow-primary-submit{width:100%;min-width:0;}
        .work-order-submit-button{width:100%;min-width:0;}
    }

    .ai-draft-card{
        margin-bottom: 16px;
        border-color: #b3d8ff;
        background: #f7fbff;
    }
    .ai-draft-card .el-card__header{
        padding: 12px 16px;
        border-bottom-color: #d9ecff;
    }
    .ai-draft-card .el-card__body{
        padding: 16px;
    }
    .ai-draft-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
    }
    .ai-draft-header-actions{
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
    }
    .ai-draft-title{
        color: #1677ff;
        font-size: 16px;
        font-weight: 600;
    }
    .ai-draft-subtitle{
        margin-left: 12px;
        color: #606266;
        font-size: 12px;
    }
    .ai-draft-actions{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 12px;
    }
    .ai-paste-zone{
        min-width: 132px;
        height: 32px;
        padding: 0 12px;
        border: 1px dashed #409eff;
        border-radius: 4px;
        color: #409eff;
        font-size: 12px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        outline: none;
        background: #fff;
    }
    .ai-paste-zone:focus{
        border-style: solid;
        background: #ecf5ff;
    }
    .ai-draft-tip{
        color: #909399;
        font-size: 12px;
    }
    .ai-image-list{
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 12px;
    }
    .ai-image-item{
        position: relative;
    }
    .ai-image{
        width: 80px;
        height: 80px;
        border-radius: 4px;
    }
    .ai-image-delete{
        position: absolute;
        top: -8px;
        right: -8px;
        padding: 5px;
    }
    .ai-result-alert{
        margin-top: 12px;
    }
    .ai-feedback-list{
        margin-top: 10px;
        padding: 8px 12px;
        border-radius: 4px;
        color: #e6a23c;
        font-size: 12px;
        line-height: 22px;
        background: #fdf6ec;
    }
    .ai-feedback-title{
        font-weight: 600;
    }
    .ai-warning-item{
        word-break: break-word;
    }
    .ai-unresolved-fields{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
        margin-top: 10px;
        color: #606266;
        font-size: 12px;
    }
    .ai-unresolved-fields .el-tag{
        margin-right: 0;
    }

    .form-section-heading{
        display: flex;
        align-items: center;
        gap: 12px;
        margin: 20px 0 10px;
        padding: 12px 16px;
        border-left: 4px solid #20a89a;
        border-radius: 4px;
        background: #eef8f7;
    }
    .form-section-heading--plain{
        border-left-color: #c0c4cc;
        background: #f5f7fa;
    }
    .form-section-index{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        background: #20a89a;
        flex-shrink: 0;
    }
    .form-section-title{
        color: #303133;
        font-size: 15px;
        font-weight: 600;
        line-height: 22px;
    }
    .form-section-description{
        color: #909399;
        font-size: 12px;
        line-height: 18px;
    }
    .flow-preview{
        color: #1677ff;
        line-height: 22px;
    }
    .flow-preview i{
        margin-right: 6px;
    }
    .result-mode-tabs{
        width: 100%;
    }
    .result-mode-tabs .el-tabs__header{
        margin: 0;
    }
    .result-mode-tabs .el-tabs__item{
        min-width: 104px;
        text-align: center;
    }
    .result-mode-tabs .el-tabs__item.is-disabled{
        cursor: not-allowed;
        opacity: .5;
    }
    .result-mode-tip{
        min-height: 22px;
        color: #606266;
        line-height: 22px;
    }
    .result-mode-form{
        margin-top: 12px;
    }
    .result-mode-lock-tip{
        margin-top: 8px;
        color: #e6a23c;
    }
    .result-mode-lock-tip i{
        margin-right: 4px;
    }
    .after-sales-product-section{
        margin: 20px 0;
    }
    .after-sales-product-heading{
        margin-bottom: 10px;
    }
    .after-sales-product-table-wrap{
        width: 100%;
        overflow-x: auto;
    }
    .box-card{
        margin-bottom: 20px;
    }
    .el-card__header {
        padding: 10px;
    }

    .el-card__body {
        padding: 0 10px 20px;
    }

    .popover-title {
        margin: 0 0 15px 0;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 100%;
    }

    .el-tag {
        margin-right: 10px;
    }
    .special-card-pay-list{
        display: flex;
        flex-wrap: wrap;
        row-gap: 6px;
    }
    .field-tip{
        margin-top: 5px;
        color: #909399;
        font-size: 12px;
        line-height: 18px;
    }
    .pre-line-text{
        white-space: pre-line;
        word-break: break-word;
    }
    .picture-requirement{
        margin-bottom: 10px;
    }
    .picture-upload-row{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
    }
    .picture-list,
    .product-picture-list{
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 10px;
    }
    .picture-item,
    .product-picture-item{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
    }
    .picture-image,
    .product-picture-image{
        width: 80px;
        height: 80px;
    }
    .picture-delete,
    .product-picture-delete{
        position: absolute;
        top: -8px;
        right: -8px;
        padding: 5px;
    }
    .production-reply{
        padding: 8px;
        border: 1px solid #e1f3d8;
        border-radius: 4px;
        background: #f0f9eb;
    }
    .el-divider__text {
        color: #209e91;
    }
    .paste-wrap{
        width: 100px;
        height: 80px;
        border: 1px dashed #209e91;
        border-radius: 4px;
        text-align: center;
        line-height: 80px;
        color: #209e91;
        cursor: pointer;
        outline: none;
    }
    .paste-wrap:focus{
        background: #f0f9eb;
        border-style: solid;
    }
    @media (max-width: 768px){
        .ai-draft-header{
            align-items: flex-start;
        }
        .ai-draft-subtitle{
            display: block;
            margin: 4px 0 0;
        }
        .ai-draft-actions .el-button{
            margin-left: 0;
        }
    }
}
</style>
